export const GLOSSARY =
[
  {
     "key":1,
     "value":"acceptable use policy (AUP)",
     "description":"A formal statement of policy signed by management and acknowledged by the user with their signature. This policy typically is enforced by the Human Resources department. The policy should state that computing resources are for company business only and that noncompany activities, including those related to religion or topics of questionable use, are prohibited. The AUP should state that possession of administrative system utilities and related system tools not specifically authorized are prohibited as contraband. This eliminates any excuses or misunderstanding and enforces separation of duties."
  },
  {
     "key":2,
     "value":"access control list (ACL)",
     "description":"A table of user login IDs specifying each user\u0027s individual authorized level of access to use computer resources. The access control list tells the computer which files the user is allowed to access."
  },
  {
     "key":3,
     "value":"access rights",
     "description":"The level of permission granted to an individual user for the purpose of reading data, writing data, or executing specific programs. Access does not ensure any form of integrity or confidentiality."
  },
  {
     "key":4,
     "value":"accountability",
     "description":"Responsibility, liability. To be accountable is to be liable for the final result or to be held responsible for one\u0027s actions."
  },
  {
     "key":5,
     "value":"accreditation",
     "description":"A formal approval by management based on perceived fitness of use. Approval may be granted for a system, site location, or function. Accreditation occurs after system certification for a period of 90 days, 180 days, or one year. Systems must be reaccredited prior to expiration of their current accreditation period."
  },
  {
     "key":6,
     "value":"ACID principle",
     "description":"ACID stands for atomicity (write all or nothing), consistency (data is restored to its original state if the write fails), isolation (each transaction is independent), and durability (completed data is retained in the database)."
  },
  {
     "key":7,
     "value":"activation criteria",
     "description":"Conditions that, when met, dictate the activation of disaster recovery or business continuity plans. Any delay or failure to activate indicates negligence. Typically, the criteria are based on impact, anticipated duration of outage, or immediate lack of sufficient information to calculate the actual impact. It\u0027s always better to overreact when compared to the consequences of an inadequate response."
  },
  {
     "key":8,
     "value":"active attack",
     "description":"An overt attack against the system or system data files. Active attacks are usually detected during routine monitoring."
  },
  {
     "key":9,
     "value":"ActiveX",
     "description":"A program applet designed by Microsoft that has access throughout the entire system. ActiveX is more dangerous than Java applets. ActiveX applets can be digitally signed using authenticode, but this does not provide any protection from malware. Malicious programmers can design ActiveX programs to circumvent or defeat the security of Microsoft Windows. As a safeguard, firewalls should always be configured to prevent the downloading of ActiveX programs. Individual computers should have ActiveX disabled."
  },
  {
     "key":10,
     "value":"address binding",
     "description":"Creating a software link (association) between the hardware MAC address of a network interface and the administratively assigned IP address."
  },
  {
     "key":11,
     "value":"administrative audit",
     "description":"Verifies that appropriate policies and procedures exist and that they have been implemented as management intended. This audit focuses on operational effectiveness and efficiency."
  },
  {
     "key":12,
     "value":"administrative controls",
     "description":"Preventative, detective, and corrective controls in which administrative policies and procedures are used."
  },
  {
     "key":13,
     "value":"Advanced Encryption Standard (AES)",
     "description":"Symmetric-key encryption system designed by Belgian mathematicians. Also known as the Rijndael, Advanced Encryption Standard (AES) replaces the outdated Data Encryption Standard (DES) previously used by the US government. AES is the de facto standard for many applications because it is approved by the US National Institute of Standards and Technology (NIST) for unclassified and certain classified information."
  },
  {
     "key":14,
     "value":"adware",
     "description":"A tiny, downloaded software program that intentionally displays or promotes advertising directly on the user\u0027s computer. It is a variation of spam or malware that disrupts the user\u0027s time and attention."
  },
  {
     "key":15,
     "value":"after-image",
     "description":"Changes to data in the database are held in a temporary file called the after-image journal. The transaction can be reversed (discarded) until the program writes the change into the master file. Also see before-image and ACID principle."
  },
  {
     "key":16,
     "value":"Agile development",
     "description":"A micromanagement methodology to force development within a series of short time boxes. Agile is used for the development of prototypes. The focus is on tactile knowledge in a person\u0027s mind rather than the use of formal System Development Life Cycle (SDLC) design and development documentation."
  },
  {
     "key":17,
     "value":"antivirus software",
     "description":"A specialized software program used to detect viruses based on a database of known behavior (signature) or an unauthorized attempt to append to or change a file."
  },
  {
     "key":18,
     "value":"applet",
     "description":"A small, downloaded program using ActiveX, Java, XML, or a similar programming language."
  },
  {
     "key":19,
     "value":"application",
     "description":"Computer software program designed for a particular purpose. Application software provides functions and stored procedures to solve a problem on behalf of the user."
  },
  {
     "key":20,
     "value":"application controls",
     "description":"The lowest level of control, usually governing system use or internal program controls. Application controls are easily subverted if higher-level controls governing the operating environment are missing or ineffective. Higher controls include general controls, pervasive controls, and detailed controls. Also see general controls, pervasive controls, and detailed controls."
  },
  {
     "key":21,
     "value":"Application layer",
     "description":"The highest layer of the OSI model is layer 7, the Application layer. It runs problem-solving software for the user. This layer provides the interface between the user and the computer program."
  },
  {
     "key":22,
     "value":"application programming interface (API)",
     "description":"A software interface designed to allow communication between different programs. APIs are used to specify the procedural rules, type, and format of data to be passed between programs. Proprietary APIs are referred to as closed. Nonproprietary APIs are called open. The API design is used by programs in both open-system and closed-system architecture for cross-compatibility."
  },
  {
     "key":23,
     "value":"application service provider (ASP)",
     "description":"See software as a service (SaaS)."
  },
  {
     "key":24,
     "value":"artificial intelligence (AI)",
     "description":"An attempt to simulate human reasoning by using a computer program with a knowledge database and abstract procedures to measure cause-and-effect relationships."
  },
  {
     "key":25,
     "value":"assessment",
     "description":"A less formal process used to determine the value of an asset and the relevance to its intended use. Assessments may be internal or external. The results of an assessment are of low to moderate value. The results are used for internal purposes only. See audit and independent audit to compare the differences."
  },
  {
     "key":26,
     "value":"asset",
     "description":"Anything of value. May be tangible or intangible and in the form of information, skilled people, money, physical goods, products, resources, recipes, or procedures."
  },
  {
     "key":27,
     "value":"assurance",
     "description":"A promise with supporting evidence given in a declaration or activity designed to instill confidence."
  },
  {
     "key":28,
     "value":"asymmetric-key encryption",
     "description":"An encryption system using two different keys. Both keys are mathematically related. Asymmetric-key encryption is not time sensitive. The private key is kept secret by the sender, and the public key is freely distributed to anyone who desires to communicate with the owner. Also known as public-key cryptography."
  },
  {
     "key":29,
     "value":"atomicity",
     "description":"A process used for database transaction integrity to ensure that the entire transaction is correctly processed or all the changes are backed out of the database."
  },
  {
     "key":30,
     "value":"attestation",
     "description":"An affirmation by the signer that all statements are true and correct. The purpose is to certify that a declaration is genuine."
  },
  {
     "key":31,
     "value":"attribute",
     "description":"In computer programming, an attribute is equivalent to a column in a database table. The attribute refers to a specific characteristic of a database entry."
  },
  {
     "key":32,
     "value":"attribute sampling",
     "description":"A technique used to estimate the rate of occurrence for a particular attribute within the subject population. In compliance testing, attribute sampling answers the question, \u0022How many?\u0022"
  },
  {
     "key":33,
     "value":"attribute-based access control (ABAC)",
     "description":"The most detailed level of access control, which matches the combined security of subject (user or program), object (data), and context of usage (need or purpose) to determine whether a request should be approved or denied. ABAC is used in mandatory access control, which also requires a centralized control approach."
  },
  {
     "key":34,
     "value":"audit",
     "description":"A formal and systematic process of collecting evidence to test or confirm a statement or to confirm a record of transaction. Also see internal audit and independent audit."
  },
  {
     "key":35,
     "value":"audit charter",
     "description":"A formal document issued by management to designate audit responsibility, authority, and accountability. The absence of a formal audit charter document would indicate a control weakness."
  },
  {
     "key":36,
     "value":"audit committee",
     "description":"A committee of the board of directors composed of financially literate executives. The purpose of the audit committee is to challenge the assertions of management by using internal and external auditors."
  },
  {
     "key":37,
     "value":"audit evidence",
     "description":"Samples collected by the auditor to prove or disprove the audit findings. Every audit must use relevant evidence of dependable quality in sufficient quantity to generate a score of success or failure."
  },
  {
     "key":38,
     "value":"audit objective",
     "description":"Specific goal(s) to be accomplished by the audit. This is the reason for the audit."
  },
  {
     "key":39,
     "value":"audit plan",
     "description":"Detailed project plan containing a list of objectives, specific tasks in proper sequence, skills matrix, written copy of data collection procedures, written audit test procedures, and the forecast illustrating scope time and cost estimates. The audit plan is an essential document to be archived with the resulting audit report for proving integrity of the corresponding results."
  },
  {
     "key":40,
     "value":"audit risk",
     "description":"The possibility that material errors may exist that the auditor is unable to detect."
  },
  {
     "key":41,
     "value":"audit scope",
     "description":"The boundaries and limitations of the individual audit. Normally, particular systems or functions that will be reviewed during the audit."
  },
  {
     "key":42,
     "value":"audit subject",
     "description":"The target to be audited. The audit subject may be a particular system, process, procedure, or department function."
  },
  {
     "key":43,
     "value":"audit trail",
     "description":"Evidence that can be reassembled in chronological order to retrace a transaction or series of transactions."
  },
  {
     "key":44,
     "value":"auditee",
     "description":"The persons and organization being audited."
  },
  {
     "key":45,
     "value":"auditing standard",
     "description":"The mandatory examination procedures to be executed during an audit to ensure consistency of findings. The auditing standard specifies a minimum level of performance. Any deviations must be well documented, with justification as to why the standard was not followed."
  },
  {
     "key":46,
     "value":"auditor",
     "description":"The person(s) performing the audit by gathering evidence, testing, and reporting the findings. Auditors should not be related to the subject of the audit, to prevent bias. Also see independence."
  },
  {
     "key":47,
     "value":"auditor\u0027s opinion",
     "description":"An overall score generated by the sufficient collection of evidence, effective testing, observations, and findings from the test results. It\u0027s actually a score based on the relevance of the test results rather than an opinion."
  },
  {
     "key":48,
     "value":"authentication",
     "description":"The process of verifying a user\u0027s identity. The user\u0027s claim will be tested against a known reference. If a match occurs, the user is authenticated and allowed to proceed. A mismatch will deny the request."
  },
  {
     "key":49,
     "value":"authentication header (AH)",
     "description":"Used in the IPsec protocol to provide integrity, authentication, and nonrepudiation by means of encryption. The authentication header contains the security associations (SAs), which are used for covert tunneling mode. The AH works with the encapsulated security protocol to both hide the internal IP address and encrypt the data payload."
  },
  {
     "key":50,
     "value":"authenticode",
     "description":"Microsoft\u0027s technique for software developers to digitally sign downloadable ActiveX applets. The authenticode design fails to provide any security from poorly written programs and does not protect the user from malicious programs designed to intentionally cause harm."
  },
  {
     "key":51,
     "value":"authorization",
     "description":"The granting of a right or authority."
  },
  {
     "key":52,
     "value":"availability",
     "description":"A term that refers to the accessibility and proper functioning of a system at the time frame required by the user."
  },
  {
     "key":53,
     "value":"backdoor",
     "description":"A hidden software-access mechanism that will bypass normal security controls to grant access into a program. A root kit is the most powerful type of backdoor because it creates covert access paths into the system. Also see trapdoor."
  },
  {
     "key":54,
     "value":"backup and recovery capability",
     "description":"The combination of software, hardware, procedures, and data files that will permit timely recovery from a failure or disaster."
  },
  {
     "key":55,
     "value":"balanced scorecard",
     "description":"A management tool that aligns individual activities to the higher-level business objectives."
  },
  {
     "key":56,
     "value":"baseband",
     "description":"A single channel for data transmission. Coax cable is an example of a baseband technology."
  },
  {
     "key":57,
     "value":"baseline",
     "description":"An agreed-upon reference point. Also see software baseline."
  },
  {
     "key":58,
     "value":"bastion host",
     "description":"A gateway host fully exposed to an external connection such as the Internet. Bastion hosts are special-purpose systems designed with their own protection to withstand normal (average) attacks. Examples include a proxy server or firewall. If compromised, the bastion will be shut down."
  },
  {
     "key":59,
     "value":"batch controls",
     "description":"Used to ensure the accuracy and correct formatting of input data. The batch controls include sequence numbering and run-to-run totals. The batch count will count the number of all the items to ensure that each transaction is processed. Batch totals can be used to verify the values within the transactions."
  },
  {
     "key":60,
     "value":"before-image",
     "description":"A temporary record of work in progress. This database journal file contains the original data before a new transaction is written. A copy of the original data is retained in this \u0022before\u0022 journal file in case the transaction fails. If the transaction fails, the change is discarded and the original data is kept. Related to the ACID principle and after-image transaction journal. Also see ACID and after-image."
  },
  {
     "key":61,
     "value":"benchmarking",
     "description":"A test to evaluate performance against a known workload or industry-accepted standard. Using the Capability Maturity Model (CMM) is a form of benchmarking."
  },
  {
     "key":62,
     "value":"best evidence",
     "description":"Refers to evidence that specifically proves or disproves a particular point. The best evidence is both independent and objective. The worst evidence is subjective or circumstantial evidence."
  },
  {
     "key":63,
     "value":"black-box testing",
     "description":"Tests the functionality of compiled software by comparing the input and output, without understanding the internal process that creates the output. The internal logic is hidden from the tester. The term black box refers to the software being in nonreadable machine format (compiled code). Almost all commercially available software is tested by using the black-box technique."
  },
  {
     "key":64,
     "value":"blackout",
     "description":"The complete failure of electrical power."
  },
  {
     "key":65,
     "value":"biometric management",
     "description":"The enforcement/overseeing of a policy concerning the intended use of biometric data with corresponding standards and procedures. Biometric management includes identifying how data is collected, stored, protected, transmitted, used, and disposed of."
  },
  {
     "key":66,
     "value":"biometric sensor",
     "description":"Special acquisition device used to create unique minutiadata representing an individual user. Sensors convert physical attributes into electrical signals, which are recorded as attribute scores for each individual user."
  },
  {
     "key":67,
     "value":"biometric system",
     "description":"A combined assembly of hardware and software that uses biometric templates, acquisition sensors, a biometric template generator, an encrypted database of biometric template data, and a complete matcher to determine whether an individual is actually a legitimate authorized user."
  },
  {
     "key":68,
     "value":"biometric template",
     "description":"Minutia data created by the biometric system\u0027s acquisition sensor, it represents unique characteristics of the legitimate authorized user that are trustworthy enough to be used for authentication."
  },
  {
     "key":69,
     "value":"biometric template generator",
     "description":"The system sensor that acquires a biometric image and converts it into biometric minutiae for digital storage or comparison."
  },
  {
     "key":70,
     "value":"biometric template matcher",
     "description":"Compares a biometric image template just acquired by the sensor to the biometric minutiae already stored inside the biometrics database. A match between the two templates will authenticate the individual, allowing access through the physical door or barrier."
  },
  {
     "key":71,
     "value":"biometrics",
     "description":"A technical process to verify a user\u0027s identity based on unique physical characteristics."
  },
  {
     "key":72,
     "value":"bitstream imaging",
     "description":"A special bit-by-bit backup of physical media that records all the contents, including deleted files and current contents of swap space or slack space. Also known as physical backup. Bitstream backups are used in forensic analysis and may be used in electronic discovery. Also see logical backup."
  },
  {
     "key":73,
     "value":"boot strapping (boot)",
     "description":"The initial loading of software to start a computer. Also see initial program load (IPL)."
  },
  {
     "key":74,
     "value":"bot-net",
     "description":"Remote-controlled robot network created from compromised computers owned by unsuspecting users. Unsuspecting victims may even be located behind a firewall on a corporate network. The bot-net operates a distributed attack against other systems or delivers email spam messages as an attack against other systems. Bot-nets are known to be as large as hundreds of thousands or even millions of systems."
  },
  {
     "key":75,
     "value":"bridge",
     "description":"A network device or software process that connects similar networks together. Network switching is based on a bridging process to join users into logical network segments. A standard bridge will forward all data packets to the other users in the subnet. A bridge operates at the OSI Data-Link layer (layer 2)."
  },
  {
     "key":76,
     "value":"broadband",
     "description":"Multiple communication channels that are multiplexed over a single cable. DSL is an example of broadband transmitted on a different frequency and sharing the same physical wire with the voice telephone circuit."
  },
  {
     "key":77,
     "value":"broadcast",
     "description":"A network transmission by one computer to all computers on the network. Ethernet uses broadcast technology to transmit data packets, which are seen by all the computers on the network."
  },
  {
     "key":78,
     "value":"brownout",
     "description":"Low voltage for an extended period of time."
  },
  {
     "key":79,
     "value":"brute force attack",
     "description":"An attempt to overpower the system or to try every possible combination of usernames and passwords until access is granted."
  },
  {
     "key":80,
     "value":"buffer",
     "description":"A temporary memory location used to stage data before or after processing."
  },
  {
     "key":81,
     "value":"bus",
     "description":"A connection shared by multiple devices. Examples include the power bus and the computer data bus."
  },
  {
     "key":82,
     "value":"bus topology",
     "description":"An early type of networking in which all the computers were connected on a single cable in a linear fashion."
  },
  {
     "key":83,
     "value":"business continuity (BC) manager",
     "description":"A specific manager with the authority of a vice president or director assigned to lead planning and exercises. Usually this person reports to the chief executive officer (CEO) or chief operating officer (COO) or holds a leadership position in the program management office. Unlike departmental managers, the BC manager has authority across departmental boundaries."
  },
  {
     "key":84,
     "value":"business continuity plan (BCP)",
     "description":"An organizational plan to continue core revenue-generating operations following a crisis or disaster. The objective of business continuity planning is to ensure uninterrupted revenue for business survival."
  },
  {
     "key":85,
     "value":"business impact analysis (BIA)",
     "description":"The process of determining the actual steps to produce the desired product or service, as it is used by the organization. The intention is to provide management with accurate information about how the business processes are performed."
  },
  {
     "key":86,
     "value":"business performance indicators",
     "description":"Business performance can be measured by a variety of indicators, including return on investment (ROI), gross profit margin (GPM), capital gains, market share, production cost, and debt ratio."
  },
  {
     "key":87,
     "value":"business process reengineering (BPR)",
     "description":"The process of streamlining existing operations in an effort to improve efficiency and reduce cost. Benefits may be derived by eliminating unnecessary steps as the organization progresses through the learning curve or by expanding capability for more work."
  },
  {
     "key":88,
     "value":"business risk",
     "description":"The inherent potential for harm in the business or industry itself as an organization attempts to fulfill its objectives. Business risks may be regulatory, contractual, or financial."
  },
  {
     "key":89,
     "value":"bypass label processing",
     "description":"An attempt to circumvent mandatory access controls by bypassing the electronic security control label. Examples include writing data to a read-only file and accessing a file that would be off-limits because of its higher security rating."
  },
  {
     "key":90,
     "value":"bytecode",
     "description":"See pseudocode."
  },
  {
     "key":91,
     "value":"cable plant",
     "description":"A physical collection of network cables contained inside a building. cache A high-speed buffer used to temporarily stage data before or after processing."
  },
  {
     "key":92,
     "value":"candidate key",
     "description":"Rows of data used with search attributes to find all matching records within the database—for example, searching the database to find the name of every hotel in Grapevine, Texas. The candidate key in this example would be the hotel."
  },
  {
     "key":93,
     "value":"Capability Maturity Model (CMM)",
     "description":"A model developed by the Software Engineering Institute to benchmark the maturity of systems and management processes. Maturity levels range from 0 to 5. Level 5 is completely documented and optimized for continuous improvement."
  },
  {
     "key":94,
     "value":"capacity monitoring",
     "description":"The process of continuously monitoring utilization in the environment against existing resource capacity. The objective is to ensure optimum use and expansion of services before an outage occurs."
  },
  {
     "key":95,
     "value":"certificate",
     "description":"A written assurance or official record representing that an event has or has not occurred. Certificates can be stored as electronic records or physical documents and are signed by the party providing a declaration of authenticity."
  },
  {
     "key":96,
     "value":"certificate authority (CA)",
     "description":"The trusted issuer of digital certificates using public- and private-key pairs. The certificate authority is responsible for verifying the authenticity of the user\u0027s identity. Also see digital certificate."
  },
  {
     "key":97,
     "value":"certificate revocation list (CRL)",
     "description":"A list that is maintained by the certificate authority and contains certificates that are revoked or expired. Also see certificate authority (CA)."
  },
  {
     "key":98,
     "value":"certification",
     "description":"A comprehensive technical evaluation process to establish compliance to a minimum requirement."
  },
  {
     "key":99,
     "value":"certification practice statement (CPS)",
     "description":"A detailed set of procedures specifying how a certificate authority governs its operation. Also see certificate authority (CA)."
  },
  {
     "key":100,
     "value":"chain of custody",
     "description":"Refers to the mandatory security and integrity requirements used in the evidence life cycle. The custodian of evidence must prove that the evidence has been kept secure with a high degree of integrity and has not been tampered with. Also see integrity."
  },
  {
     "key":101,
     "value":"change control board (CCB)",
     "description":"A management review process to ensure awareness and control of changes in the IT environment. A change control board provides separation of duties."
  },
  {
     "key":102,
     "value":"change control process (CCP)",
     "description":"A formal review of proposed changes using a systematic methodology. Also see methodology."
  },
  {
     "key":103,
     "value":"ciphertext",
     "description":"An encrypted message displayed in unreadable text that appears as gibberish. The message is displayed in cipher form."
  },
  {
     "key":104,
     "value":"circuit switching",
     "description":"All communications are transmitted over a dedicated circuit such as a T1 leased line telephone circuit. Circuit switching is the opposite of packet switching. Also see packet switching."
  },
  {
     "key":105,
     "value":"circuit-level gateway",
     "description":"Refers to a proxy firewall. No data packets are forwarded between the internal and external network, except by the proxy application. The proxy application is required to complete the data transmission circuit. Also see proxy firewall."
  },
  {
     "key":106,
     "value":"classified information",
     "description":"Data is ranked somewhere in a protection scheme (aka protection plan) that has been clearly identified to the users and includes handling procedures on how the information should be controlled. Also see unclassified information."
  },
  {
     "key":107,
     "value":"clear text",
     "description":"A message in clear text is completely readable to a human. The message can be clearly read."
  },
  {
     "key":108,
     "value":"client",
     "description":"A person or organization with the authority to request an audit. The auditor\u0027s report of findings is presented to the client at the conclusion of the audit. The client may be internal or external to the auditee. Also see auditee."
  },
  {
     "key":109,
     "value":"closed system",
     "description":"Software containing methods and programming of a proprietary design, which remains the property of the software creator. Most commercial software is closed system. Closed systems can exchange data with other programs by using a specific application programming interface (API). Microsoft Windows is an example of a closed system containing proprietary design."
  },
  {
     "key":110,
     "value":"cloud computing",
     "description":"Application software hosted by a remote vendor and offered across the Internet to subscribers. Cloud computing is a variation of the application service provider (ASP) and software as a service (SaaS) models. Security issues are a major concern because specific details of the communications network, network servers, internal software application, and vendor\u0027s operation may not be known by the user. Auditors need to remain aware that cloud computing may cut operating expense, bypass IT controls, fuel an individual\u0027s political agenda, circumvent management, or violate data control requirements. Also see application service provider (ASP) and software as a service (SaaS)."
  },
  {
     "key":111,
     "value":"cold site",
     "description":"A physical location that can be used for disaster recovery of noncritical processes. The cold site is no more than a building with basic utility service. The entire computing environment must be shipped in and then assembled. The cold site will be ready for production use in weeks or months."
  },
  {
     "key":112,
     "value":"Committee of Sponsoring Organizations (COSO)",
     "description":"A voluntary association of governments (members) engaged in regulating the integrity of financial transactions worldwide. COSO is based on London\u0027s banking system for investment, stock trading, and transaction controls. COSO represents the foundation of auditing laws and audit controls worldwide. ISACA represents a narrow derivative of IT-specific controls attempting to implement an IT-only portion of the COSO control model. COSO controls are used in conjunction with those of the International Organization for Standardization (ISO) and the Organization for Economic Cooperation and Development (OECD), which specify the details and interpretation of laws each country needs to adopt in support of world trade."
  },
  {
     "key":113,
     "value":"Common Criteria",
     "description":"An international standard (ISO 15408) for testing criteria of computer security controls. All ISO member countries are expected to use the Common Criteria standard with testing performed by an ISO 17025–certified laboratory testing facility. Common Criteria is currently in use by Canada, France, Germany, the Netherlands, the United Kingdom, and the United States."
  },
  {
     "key":114,
     "value":"compensating control",
     "description":"An internal control that reduces the potential for loss by error or omission. Supervisory review and audit trails are compensating controls for a lack of separation of duties."
  },
  {
     "key":115,
     "value":"compile",
     "description":"An automated process used by software developers to convert human-readable computer programs into executable machine language. Compiled computer software runs faster than interpreted program scripts. Compiled computer programs cannot be read by humans."
  },
  {
     "key":116,
     "value":"compliance audit",
     "description":"A type of audit that determines whether internal controls are present and functioning effectively."
  },
  {
     "key":117,
     "value":"compliance testing",
     "description":"The testing of internal controls to determine whether they are functioning correctly."
  },
  {
     "key":118,
     "value":"computer console",
     "description":"Physical access to the computer\u0027s primary input/output terminal, usually the video display and keyboard. Access to the computer console is a security risk that must be controlled."
  },
  {
     "key":119,
     "value":"computer-assisted audit tools (CAAT)",
     "description":"The family of automated test software using a computerized audit procedure with specialized utilities."
  },
  {
     "key":120,
     "value":"confidence coefficient",
     "description":"The quantified probability of error. A confidence coefficient of 95 percent is considered a high level of confidence in IS auditing."
  },
  {
     "key":121,
     "value":"confidentiality",
     "description":"The protection of information held in secret for the benefit of authorized users."
  },
  {
     "key":122,
     "value":"configuration management",
     "description":"An administrative process of being able to prove the documented design as built by verifying the correct version of all the individual components used in final construction. The three elements of configuration management are control, accounting, and reporting."
  },
  {
     "key":123,
     "value":"Constructive Cost Model (COCOMO)",
     "description":"An early software project estimation technique used to forecast the time and effort required to develop a software program based on size and complexity."
  },
  {
     "key":124,
     "value":"continuity of operations",
     "description":"Preemptive activities designed to ensure the continuous operation of core processes, utilities, and lifeline services. Vendors involved in lifeline medical services, power utilities, communications, national infrastructure supply chains, or food and water are expected to provide their services without interruption regardless of whether they generate revenue or not."
  },
  {
     "key":125,
     "value":"contraband software",
     "description":"Any system utility or special software not required in the specific performance of a person\u0027s job duties. A tightly controlled software policy prevents any excuses for violating separation of duties. Examples of contraband software include password crackers, network discovery tools, CAAT software, traffic generators, disk-wiping utilities, and known hacking software. Violations should be grounds for immediate termination following the conclusion of an investigation."
  },
  {
     "key":126,
     "value":"control",
     "description":"The power to regulate or restrict activities. IS controls are used as a safeguard to prevent loss, error, or omission."
  },
  {
     "key":127,
     "value":"control environment",
     "description":"A space designed to protect assets by using sufficient physical and technical controls to prevent unauthorized access or compromise. The computer room is a control environment."
  },
  {
     "key":128,
     "value":"control group",
     "description":"Members of the operations staff responsible for collecting data from users for input to the computer system."
  },
  {
     "key":129,
     "value":"control risk",
     "description":"The risk that errors may be introduced or not identified and corrected in a timely manner. The risk of losing control."
  },
  {
     "key":130,
     "value":"control self-assessment",
     "description":"A formal review executed by the user to assess the effectiveness of controls. The purpose of the control self-assessment is to induce ownership by the user and to facilitate improvement."
  },
  {
     "key":131,
     "value":"corrective control",
     "description":"A control designed to minimize the impact of an error by repairing the condition or executing an alternative procedure. Examples of corrective controls include data restoration from tape backup, hot sites, and automated failover systems."
  },
  {
     "key":132,
     "value":"cost of asset",
     "description":"The capital expense of an asset may be measured as total ownership cost (TOC). The cost of the asset is the cumulative total expense based on purchase price, delivery cost, implementation cost, and effective downtime."
  },
  {
     "key":133,
     "value":"cracker",
     "description":"A malicious computer attacker who attempts to break into a system. Synonymous with the term malicious hacker. Also see hacker."
  },
  {
     "key":134,
     "value":"crash dump",
     "description":"A special diagnostic file created when a computer system crashes. The contents represent the data being processed at the time of the crash, including contents of the memory registers and tasks running when the crash occurred. Crash dump files vary according to the operating system. Contents of this file are extremely valuable in forensic analysis."
  },
  {
     "key":135,
     "value":"Critical Path Methodology (CPM)",
     "description":"The path of execution that accomplishes the minimum yet most important objectives of the project. The critical path is the longest single route through a network diagram and takes the shortest time to accomplish the main objectives. Critical path items represent mandatory tasks that, if not accomplished, would wreck the project."
  },
  {
     "key":136,
     "value":"critical success factor (CSF)",
     "description":"A process that must occur perfectly every single time in order to be successful. To fail a critical success factor would be a showstopper."
  },
  {
     "key":137,
     "value":"crossover error rate (CER)",
     "description":"In biometrics, crossover error rate refers to adjusting sensitivity of the system to specifically favor either speed or increased accuracy. The most common error in biometrics is false rejection (type 1 error, aka FRR, or false rejection rate), which poses little risk to an organization\u0027s security requirements. The greater risk of breach occurs when an illegitimate user is accepted in error (type 2 error, aka FAR, or false acceptance rate). The crossover rate indicates the level of favoritism protecting against either FRR or FAR. Also see equal error rate (EER)."
  },
  {
     "key":138,
     "value":"cross-site scripting (XSS)",
     "description":"Very common programming technique that allows one program, such as a shopping cart, to send data to another website in real time. The shopping cart sends a transaction approval message to a different website, which provides access or a file to download. XSS creates a serious vulnerability unless strong cryptographic controls are used to authenticate that the request is actually valid. Static passwords will not protect against XSS attacks."
  },
  {
     "key":139,
     "value":"cryptographic system",
     "description":"The implementation of a computer program using a cryptographic algorithm and keys to encrypt and decrypt messages."
  },
  {
     "key":140,
     "value":"cryptography",
     "description":"The theories and methods of converting readable text into undecipherable gibberish and later reversing the process to create readable text. The purpose of cryptography is to hide information from other people."
  },
  {
     "key":141,
     "value":"crystal-box testing",
     "description":"See white-box testing."
  },
  {
     "key":142,
     "value":"cyclic redundancy check (CRC)",
     "description":"A simple error-detection process whereby the contents are divided by a number prior to transmission. After transmission, the process is rerun to determine whether an error occurred. A value of zero indicates that the transmission was successful."
  },
  {
     "key":143,
     "value":"data classification",
     "description":"A process of ranking information based on its value or requirements for secrecy."
  },
  {
     "key":144,
     "value":"data custodian",
     "description":"The individual charged with protecting data from a loss of availability, loss of integrity, or loss of confidentiality. The data custodian implements controls appropriate to the desires of the data owner and data classification."
  },
  {
     "key":145,
     "value":"data dictionary",
     "description":"A standardized reference listing of all the programmer\u0027s data descriptions and files used in a computer program."
  },
  {
     "key":146,
     "value":"Data Encryption Standard (DES)",
     "description":"A cryptographic symmetric-key algorithm implemented by the US government from 1972 to 1993. The DES standard was modified to use a triple process of encryption and decryption in an attempt to improve confidentiality (triple DES). DES was replaced by the Advanced Encryption Standard (AES). DES is commonly used in older devices. Also see Advanced Encryption Standard (AES)."
  },
  {
     "key":147,
     "value":"data integrity controls",
     "description":"Procedures to ensure the appropriateness and accuracy of information."
  },
  {
     "key":148,
     "value":"data mart",
     "description":"A group of data selected from a data warehouse for analysis. The data selected is of particular interest to a group of people."
  },
  {
     "key":149,
     "value":"data mining",
     "description":"The process of analyzing volumes of data to determine correlations that may be useful."
  },
  {
     "key":150,
     "value":"data owner",
     "description":"The individual or executive responsible for the integrity of information. The duties of the owner include specifying appropriate controls, identifying authorized users, and appointing a custodian."
  },
  {
     "key":151,
     "value":"data retention",
     "description":"See records management."
  },
  {
     "key":152,
     "value":"data set",
     "description":"A set of related data files."
  },
  {
     "key":153,
     "value":"database",
     "description":"A collection of persistent data items that are maintained in a grouping."
  },
  {
     "key":154,
     "value":"database schema",
     "description":"The data structure and design of a database that represents a logical layout or schema."
  },
  {
     "key":155,
     "value":"Data-Link layer",
     "description":"The transmit-and-receive protocol between networked devices. Data-Link operates on OSI layer 2."
  },
  {
     "key":156,
     "value":"data-oriented database (DODB)",
     "description":"A data collection designed around relevant information in a known format. The database and the program methods operate separately from each other."
  },
  {
     "key":157,
     "value":"decision support system (DSS)",
     "description":"A database information system with scenario models designed to convey important facts and details to aid the decision process."
  },
  {
     "key":158,
     "value":"decryption",
     "description":"The process of reversing encryption to convert unintelligible ciphertext into human-readable clear text."
  },
  {
     "key":159,
     "value":"default gateway",
     "description":"The address of a router used to communicate with systems located on a different subnet or different network."
  },
  {
     "key":160,
     "value":"defense-in-depth (DID)",
     "description":"A process of building layers of defensive controls for protective assurance. Also known as a layered defense strategy."
  },
  {
     "key":161,
     "value":"defuzzification",
     "description":"To sharpen the details of an average population by using a stratified mean (for example, demographics) to further define the data into small units."
  },
  {
     "key":162,
     "value":"deleted files",
     "description":"Computer files remain on the hard disk after deletion. To conserve processing, space occupied by deleted files is simply marked as eligible for overwriting. Deleted files that have not been overwritten may be recovered by using a simple recovery utility or forensic analysis. Use of an overwriting utility or physical destruction is necessary to prevent unauthorized disclosure of deleted files."
  },
  {
     "key":163,
     "value":"demilitarized zone (DMZ)",
     "description":"See screened subnet."
  },
  {
     "key":164,
     "value":"denial of service (DoS)",
     "description":"An attack designed to prevent the user from accessing the computer system."
  },
  {
     "key":165,
     "value":"detailed controls",
     "description":"Lower-level controls placed on specific procedures."
  },
  {
     "key":166,
     "value":"detection risk",
     "description":"The risk that an auditor will not be able to detect material error conditions (faults) that exist."
  },
  {
     "key":167,
     "value":"detective control",
     "description":"A control designed to report items of concern including errors, omissions, and unauthorized access."
  },
  {
     "key":168,
     "value":"dictionary attack",
     "description":"An attack used to discover system passwords by loading all the words found in a language dictionary into a password-cracking utility. The password-cracking utility will encrypt each word by using the same method as the operating system. Matching encrypted passwords are identified, and the originating word is displayed to the attacker as the unencrypted password."
  },
  {
     "key":169,
     "value":"differential backup",
     "description":"A file backup method that copies every file that has been added or changed since the last full backup. A differential backup does not set the final archive bit flag."
  },
  {
     "key":170,
     "value":"digital certificate",
     "description":"An encrypted computer file containing unique information about the identity of the individual and the issuer of the certificate. Digital certificates are used to verify the authenticity of a remote system. Digital certificates are required to enable Secure Shell (SSH) and Secure Sockets Layer (SSL). See also Secure Shell (SSH) and Secure Sockets Layer (SSL)."
  },
  {
     "key":171,
     "value":"digital rights management (DRM)",
     "description":"A management systems that uses encryption and/or digital certificates to enforce licensing of electronic files (music, movies, e-books, and so forth). DRM is used to help prevent bootlegging of illegal copies. The electronic file contains a special DRM interface that uses the vendor\u0027s public key to unlock the product for authorized users. Depending on the vendor\u0027s implementation, DRM may or may not use digital certificates as part of the protection mechanism."
  },
  {
     "key":172,
     "value":"digital signature",
     "description":"An encrypted hash of an electronic file. The subject file is processed by using a hash algorithm such as MD5 or SHA-1. The resulting hash output file is encrypted with the sender\u0027s private key. This encrypted hash file is known as a digital signature that is related to both the sender and the subject file. The signature is verified by using the sender\u0027s public key to decrypt the hash."
  },
  {
     "key":173,
     "value":"disaster recovery plan (DRP)",
     "description":"A set of procedures for providing an emergency response following a disaster. The objective is to rebuild the organization to a state equal to its state prior to the disaster. Disaster recovery does not provide for losses of market share and revenue. Business continuity is the next step above disaster recovery."
  },
  {
     "key":174,
     "value":"discovery sampling",
     "description":"The process of searching 100 percent of the available records for specific attributes to determine the probability of occurrence. Used when the likelihood of evidence is low or extreme accuracy is required. The intention is to discover whether a particular situation has occurred. Common examples include forensic investigations and identifying correlations from unexpected events."
  },
  {
     "key":175,
     "value":"discretionary access control (DAC)",
     "description":"A type of access control in which a person of authority decides to grant or revoke access for an individual. The decision may be based on need or desire."
  },
  {
     "key":176,
     "value":"disk imaging",
     "description":"See bitstream imaging."
  },
  {
     "key":177,
     "value":"disk mirroring",
     "description":"See mirrored."
  },
  {
     "key":178,
     "value":"disk strings",
     "description":"The orderly connection of multiple disk drives in a storage array. Strings of individual disks are connected for use in RAID subsystems. Also see Redundant Array of Independent Disks (RAID)."
  },
  {
     "key":179,
     "value":"disposal (SDLC phase 7)",
     "description":"The manner in which hardware and software assets are authorized for retirement without the loss of data records. Data must be archived according to legal commitments and regulations. No one in the organization should profit from the disposal process. Also see System Development Life Cycle (SDLC)."
  },
  {
     "key":180,
     "value":"distributed denial-of-service attack (DDoS)",
     "description":"A particularly vicious form of denial-of-service attack that is launched concurrently from multiple systems."
  },
  {
     "key":181,
     "value":"domain",
     "description":"A kingdom or political territory of direct influence."
  },
  {
     "key":182,
     "value":"Domain Name System (DNS)",
     "description":"An Internet protocol that looks up the server\u0027s IP address by using the server hostname, such as www.certtest.com. The Internet domain names and IP addresses are loaded into a server running the domain name service."
  },
  {
     "key":183,
     "value":"downtime",
     "description":"A resource or system being unavailable to the user for any reason whatsoever. Downtime may be the result of a planned outage for maintenance or backups or an unplanned outage due to a failure."
  },
  {
     "key":184,
     "value":"dry pipe",
     "description":"A type of fire-suppression system in which the pipes remain dry until seconds after the release is required. Most dry-pipe systems utilize compressed gas to minimize the chance of leakage due to corrosion or freezing conditions."
  },
  {
     "key":185,
     "value":"due care",
     "description":"The level of care that a normal, prudent individual would give in a certain situation."
  },
  {
     "key":186,
     "value":"dumpster diving",
     "description":"The process of digging through trash in a dumpster to recover evidence or improperly disposed-of records. The same process is frequently used by government agents and law enforcement to gather evidence; therefore, it\u0027s legal unless the person is trespassing. Trespassing is unnecessary if the refuse is going to be unloaded at the public waste dump. A hacker or investigator can pick through the trash after it\u0027s unloaded at the dump or recycler."
  },
  {
     "key":187,
     "value":"electromagnetic interference (EMI)",
     "description":"Magnetic waves of interference generated by electricity."
  },
  {
     "key":188,
     "value":"Electronic Data Interchange (EDI)",
     "description":"Used for e-commerce between two organizations for communicating information about purchases and payment. EDI mapping converts the names of data elements (data fields) between two trading organizations. Traditional EDI transmits data through a value-added network (VAN) operated by a service provider. Web-based EDI transmits data across the Internet."
  },
  {
     "key":189,
     "value":"electronic discovery (e-discovery)",
     "description":"The process of searching electronic records to gather evidence. The legal discovery process allows another party the right to investigate records for the purpose of compiling evidence relevant to their claim. Electronic discovery may include recovery of deleted files and the search of standing data on offline media, including backup tapes. Persons accused of obstructing the discovery process face serious criminal charges. Also see deleted files and standing data."
  },
  {
     "key":190,
     "value":"electronic vaulting",
     "description":"A process of transmitting data to a remote backup site. This ensures that the most recent files are available in the event of a disaster. A common implementation is to transmit live data files to a remote server."
  },
  {
     "key":191,
     "value":"elliptic curve cryptography",
     "description":"A new type of encryption using specific points on a three-dimensional random curve as the encryption key."
  },
  {
     "key":192,
     "value":"emergency management (EM)",
     "description":"Provides organizational control for evacuation and rescue assistance during an emergency, crisis, or disaster. The focus of emergency management is to preserve life regardless of the disruption to the business it will create as well as the disruption to the economy or the inconvenience to an individual\u0027s objective. Saving lives or preservation of life is always the exclusive top priority."
  },
  {
     "key":193,
     "value":"emergency management team (EMT)",
     "description":"Senior executives with full delegation of authority to make decisions on behalf of the entire organization without delays or approval by other executives. During business continuity events or disaster recovery, this team will make the best possible decisions and take the necessary actions for the survival of the organization."
  },
  {
     "key":194,
     "value":"Emergency Operations Center (EOC)",
     "description":"Alternate command post that houses the emergency management team (EMT) during business continuity events or disaster recovery. Also see emergency management team (EMT)."
  },
  {
     "key":195,
     "value":"emergency power off (EPO)",
     "description":"A switch that shuts off computer room power in an emergency. The national fire protection act requires an emergency power disconnect to protect human life from electrocution. The EPO switch is located near the exit door."
  },
  {
     "key":196,
     "value":"encryption",
     "description":"The process of converting human-readable clear text into decipherable gibberish. The objective is to hide the contents of the file from other people."
  },
  {
     "key":197,
     "value":"encryption algorithm",
     "description":"A mathematical transformation procedure used to encrypt and decrypt files."
  },
  {
     "key":198,
     "value":"encryption key",
     "description":"A unique randomizer used by the encryption algorithm to ensure confidentiality. Strength of symmetric-key encryption and the PKI private key is based on the absolute secrecy of the secret/private key. Secrecy is dependent on limiting use of the key, isolating the key, and regular rotation (changing the key). Also see symmetric-key encryption (secret key) and public-key interchange (PKI)."
  },
  {
     "key":199,
     "value":"end state",
     "description":"A description of the anticipated final outcome. The end state explains the attributes of the finished product."
  },
  {
     "key":200,
     "value":"enterprise resource planning (ERP)",
     "description":"An integrated database used for planning resource requirements of multiple departments."
  },
  {
     "key":201,
     "value":"entity-relationship diagram (ERD)",
     "description":"A diagram of data elements and their relationship to other data. The ERD specifies data names and data attributes to be used by the software program being developed. The ERD is created in the requirements and design phase to build a database schema."
  },
  {
     "key":202,
     "value":"equal error rate (EER)",
     "description":"A setting used in biometrics when adjusting sensitivity of the system. It creates a 50/50 compromise between the false acceptance rate (FAR, authorized user is refused) and the false rejection rate (FRR, illegitimate user is accepted). Also see the opposing definition of crossover error rate (CER). Note that some ISACA documents and exam questions may mistakenly use EER and CER as synonyms. EER and CER are very different settings."
  },
  {
     "key":203,
     "value":"ethics",
     "description":"Discipline of following forthright and honest conduct without impropriety, deceit, or conflicting agenda."
  },
  {
     "key":204,
     "value":"evidence",
     "description":"A collection of verifiable information that is used to prove or disprove a point. The best evidence is both independent and objective."
  },
  {
     "key":205,
     "value":"evidence timing",
     "description":"The timely disclosure of evidence relevant to the situation. Evidence timing in computer systems also refers to the time window in which data is available before being lost or overwritten during normal processing."
  },
  {
     "key":206,
     "value":"evolutionary development",
     "description":"See iterative development."
  },
  {
     "key":207,
     "value":"exception report",
     "description":"A report identifying data and transactions that may be incorrect and may warrant additional attention. Exception reports can be manual or automated."
  },
  {
     "key":208,
     "value":"expert",
     "description":"An individual with a significant amount of direct experience, or special training with direct experience, and the ability to deduce a correct conclusion when everyone else would form an incorrect conclusion."
  },
  {
     "key":209,
     "value":"expert system",
     "description":"Specialized computer database software used to provide a recommendation based on the knowledge recorded from an expert. Expert systems possess between 50,000 and 100,000 discrete points of information. The system uses an inference engine to identify possible conditions relating to the problem and their meaning."
  },
  {
     "key":210,
     "value":"exposure",
     "description":"The adverse consequence that will occur if a potential threat becomes reality."
  },
  {
     "key":211,
     "value":"Extensible Authentication Protocol (EAP)",
     "description":"A newer security protocol used in wireless networks with automatic encryption-key generation and authentication. EAP is a component of the new 802.11i standard known as Robust Security Network (RSN). EAP replaces the seriously insecure method of using a preshared encryption key in the outdated Wired Equivalent Privacy (WEP) protocol. Also see Robust Security Network (RSN) and Wired Equivalent Privacy (WEP)."
  },
  {
     "key":212,
     "value":"Extensible Markup Language (XML)",
     "description":"A universal program architecture designed to share information between different programming languages. XML uses three underlying programming specifications: SOAP (originally called Simple Object Access Protocol) is used to define APIs; Web Services Description Language (WSDL) identifies the format to use; and Universal Description, Discovery, and Integration (UDDI) protocol acts as an online directory of available web services."
  },
  {
     "key":213,
     "value":"external audit",
     "description":"An audit performed by an external party, including business partners. External audits may be biased if the auditor is related to the auditee through a trading partner relationship (client, vendor, and subcontractor). Also see independent audit."
  },
  {
     "key":214,
     "value":"extranet",
     "description":"An Internet communication server used to exchange files between the organization and external business partners."
  },
  {
     "key":215,
     "value":"failure to enroll (FTE)",
     "description":"An error in the collection of biometric data that prevents the information from being recorded."
  },
  {
     "key":216,
     "value":"false acceptance rate (FAR), type 2 error",
     "description":"An error condition in biometrics that allows an unwanted user with permission to access the system by mistake. This is a less common error since falsely granting access to an unauthorized person is supposed to be rare. Also see biometrics."
  },
  {
     "key":217,
     "value":"false positive",
     "description":"Generating an alert by mistake or error."
  },
  {
     "key":218,
     "value":"false rejection rate (FRR), type 1 error",
     "description":"Used in biometrics, false rejection means to reject access to an authorized user by mistake. This is the most common type of biometric authentication error. Also see biometrics."
  },
  {
     "key":219,
     "value":"fault-tolerant systems",
     "description":"A system that can continue to operate after a single failure condition has occurred. RAID systems are designed to be tolerant of individual disk failures. The success of the fault-tolerant system depends on the system being able to identify that the fault has occurred. Also see Redundant Array of Inexpensive Disks (RAID)."
  },
  {
     "key":220,
     "value":"feasibility study (SDLC phase 1)",
     "description":"An initial study to determine the benefits that will be derived from a new system and the payback schedule for the investment required. Also see System Development Lifecycle (SDLC)."
  },
  {
     "key":221,
     "value":"financial audit",
     "description":"A review of financial records to determine their accuracy."
  },
  {
     "key":222,
     "value":"fire-control system",
     "description":"A fire-suppression system using water or chemicals to extinguish a fire in the data processing facility."
  },
  {
     "key":223,
     "value":"firewall",
     "description":"According to The American Heritage Dictionary, a firewall is a fireproof wall used as a barrier to prevent the spread of fire. In information systems, the term refers to a combination of hardware and software used to restrict access between public and private networks."
  },
  {
     "key":224,
     "value":"firmware",
     "description":"The solid-state memory chips on a circuit board containing a read-only program designed to operate the hardware."
  },
  {
     "key":225,
     "value":"flowchart",
     "description":"A systematic diagram that details the procedures for data manipulation and data transformation in a computer program. The program flowchart is developed during SDLC design in phase 2."
  },
  {
     "key":226,
     "value":"foreign key",
     "description":"Data in the database is stored in separate tables to improve speed. A foreign key is the link between data in different database tables. When the links are valid, the database has referential integrity. Also see referential integrity."
  },
  {
     "key":227,
     "value":"formal",
     "description":"Documented in writing and authorized by management."
  },
  {
     "key":228,
     "value":"fourth-generation language (4GL)",
     "description":"An English-like programming language with integrated database support. 4GL programming tools allow the forms and database to be generated by using a drag-and-drop functionality. The 4GL does not create the data transformation procedures necessary for business functionality."
  },
  {
     "key":229,
     "value":"full backup",
     "description":"The process of copying every file that exists onto backup media such as a tape cartridge. The full backup is used in combination with incremental or differential backup strategies to restore the most recent copy of data. The ability to restore files from a full backup is used to calculate the recovery point objective (RPO). Files that cannot be restored are lost."
  },
  {
     "key":230,
     "value":"function point analysis (FPA)",
     "description":"A software estimation method used to forecast development based on the number of system inputs, number of outputs, and complexity. FPA is used in the SDLC feasibility study to calculate resources and time required. FPA can be used as a baseline to measure the progress of software development."
  },
  {
     "key":231,
     "value":"function testing",
     "description":"Tests run during software development to determine the integrity of specific program functions."
  },
  {
     "key":232,
     "value":"fuzzification",
     "description":"Reducing the detail in an average by using an unstratified mean to roll the details into a larger lump-sum value."
  },
  {
     "key":233,
     "value":"gateway",
     "description":"A device running software to transfer data between two networking protocols. The gateway is an OSI layer 7 application. An example is a mainframe gateway converting TCP/IP to 3,270 sessions."
  },
  {
     "key":234,
     "value":"general controls",
     "description":"Higher-level policies, standards, and procedures used across the entire organization to govern everyone\u0027s behavior."
  },
  {
     "key":235,
     "value":"Generally Accepted Accounting Principles (GAAP)",
     "description":"A well-recognized set of agreed-upon procedures for auditing financial records and information systems."
  },
  {
     "key":236,
     "value":"guideline",
     "description":"A list of recommendations to follow in the absence of an existing standard."
  },
  {
     "key":237,
     "value":"hacker",
     "description":"A malicious attacker of a computer system. A secondary meaning in computer programming is a programmer able to generate usable applications where none existed previously."
  },
  {
     "key":238,
     "value":"halon",
     "description":"A chlorine-based gas previously used in fire-suppression systems. Production of gaseous halon 1301 has been banned since 1994 because of the damaging effects of chlorine products on the earth\u0027s ozone. Halon is still used on aircraft because of the severity of fires in flight. Computer room halon has been replaced by FM-200, NAF-S-3, and other products."
  },
  {
     "key":239,
     "value":"hand geometry",
     "description":"Used in biometrics to verify a user\u0027s identity based on the unique three-dimensional geometry of the human user\u0027s hand. Common examples include checking wrinkle patterns, measuring joints, and analyzing blood-vessel patterns. Also see biometrics."
  },
  {
     "key":240,
     "value":"hash file",
     "description":"A mathematical value generated from the original message file for verifying integrity. The sender runs their original message through a hash algorithm to produce a unique hash value. The sender sends their message and hash file to the recipient. The recipient reruns the same hash process and compares the sender\u0027s hash file against the hash generated by the recipient. The purpose of a hash file is to determine whether any changes have occurred to the original message file. Matching hash files indicate that no changes occurred; different hash values indicate that the message has been altered."
  },
  {
     "key":241,
     "value":"hash message authentication code (HMAC)",
     "description":"A HMAC is created by the combination of a hashed message file used to verify message integrity (to prove no changes occurred) that is then encrypted to provide authentication of the sender. The more common hashing algorithms with encryption are MD5 and SHA-1 (also known as SHA-160). Newer HMAC versions include SHA-256 and SHA-512. The format is [HMAC name] dash [output size]. SHA-512 means SHA algorithm with 512 output size."
  },
  {
     "key":242,
     "value":"hashing algorithm",
     "description":"The mathematical formula used to reduce the contents of any size message file into a smaller output file representing a unique value that is very difficult to duplicate. The hash algorithm creates a unique output file that can be used like a tamper seal. If the source message is altered, the hashing algorithm generates a different hash value when regenerated by the recipient. Both sender and recipient must use the same hash algorithm."
  },
  {
     "key":243,
     "value":"heuristics",
     "description":"Programmed rules inside the database used to evaluate data by sorting for possible correlations. Used in expert systems, decision support systems, email spam filters, and many common business applications. Antivirus software and intrusion detection and prevention systems use heuristics to determine which requests to accept or discard. Also see expert systems, decision support systems, Antivirus software, and intrusion detection and prevention systems."
  },
  {
     "key":244,
     "value":"honey net",
     "description":"A fake network created to entice a hacker to attack. The purpose is for the attack to generate an alarm signaling the early warning of a hacker\u0027s presence."
  },
  {
     "key":245,
     "value":"honey pot",
     "description":"An individual system set up to entice a hacker and generate an early warning alarm of the hacker\u0027s presence."
  },
  {
     "key":246,
     "value":"host based",
     "description":"Describes software that is installed on an individual host for the purpose of monitoring activity on that specific host."
  },
  {
     "key":247,
     "value":"host enumeration",
     "description":"Automated software discovery of all the active hosts on a network."
  },
  {
     "key":248,
     "value":"hot site",
     "description":"An alternate processing facility that is fully equipped with all the necessary computer equipment and capable of commencing operation as soon as the latest data files have been loaded. Hot sites are capable of being in full operation within minutes or hours."
  },
  {
     "key":249,
     "value":"hub",
     "description":"See network hub."
  },
  {
     "key":250,
     "value":"hybrid sourcing",
     "description":"A combination of using in-house workers and outsourcing selected processes. Also see outsourcing."
  },
  {
     "key":251,
     "value":"identification",
     "description":"The process of determining a user\u0027s identity based on their claim of identity. The identity claimed by the user must be verified with an authentication process before access is granted."
  },
  {
     "key":252,
     "value":"immunization",
     "description":"See inoculation."
  },
  {
     "key":253,
     "value":"impact",
     "description":"The level of damage resulting from a materialized threat."
  },
  {
     "key":254,
     "value":"incident",
     "description":"Any disruptive event, especially one that may cause harm."
  },
  {
     "key":255,
     "value":"Incident Command System (ICS)",
     "description":"ICS is the internationally recognized, government-mandated standard for crisis command during disaster recovery and business continuity events."
  },
  {
     "key":256,
     "value":"incident commander (IC)",
     "description":"Under the international Incident Command System (ICS), the incident commander is the first person to arrive on the scene regardless of training or experience. Even a four-year-old child calling 911 for help is the initial incident commander until relieved by a more qualified person. The incident commander directs the emergency response activities."
  },
  {
     "key":257,
     "value":"incident handling",
     "description":"The systematic process of responding to an incident in order to determine its significance and impact. Proper incident handling will prevent negligent activities that could destroy meaningful evidence. A computer incident always has the potential of being a cybercrime scene."
  },
  {
     "key":258,
     "value":"incremental backup",
     "description":"The process of backing up only the files that have changed since the last backup was run. An incremental backup uses the file archive bit flag to signal files that should be copied to the backup tape."
  },
  {
     "key":259,
     "value":"independence",
     "description":"Independence in an audit refers to the auditor not being related to the audit subject. The desire is for the auditor to be objective and free of conflict because they are not related to the audit subject."
  },
  {
     "key":260,
     "value":"independent audit",
     "description":"Independent audits are conducted by an auditor who is not related to the auditee. These audits therefore represent a high value of assurance that can be used for external purposes, including regulatory licensing."
  },
  {
     "key":261,
     "value":"information assets",
     "description":"Data that has a value."
  },
  {
     "key":262,
     "value":"information processing facility (IPF)",
     "description":"The building that houses the data center."
  },
  {
     "key":263,
     "value":"Information Systems (IS) steering committee",
     "description":"A committee composed of business executives for the purpose of conveying current business priorities and objectives to IT management. The steering committee provides governance for major projects and the IT budget."
  },
  {
     "key":264,
     "value":"Information Technology (IT) governance",
     "description":"A clearly stated process of leadership to lead and control the performance expected from the IT function. The focus of IT governance is control over the technology environment."
  },
  {
     "key":265,
     "value":"inherent risk",
     "description":"The natural or built-in risk that always exists."
  },
  {
     "key":266,
     "value":"initial program load (IPL)",
     "description":"Computer systems are susceptible to compromise while they are loading and before the security control front end becomes active. Computer software is vulnerable to configuration changes during the initial program loading. A system in IPL mode is in supervisory mode."
  },
  {
     "key":267,
     "value":"inoculation",
     "description":"A technique used by antivirus software to replace the original end-of-file (EOF) marker with a new EOF marker generated by the antivirus program. Anything attempting to attach itself to the new EOF marker indicates a virus attack."
  },
  {
     "key":268,
     "value":"integrated audit",
     "description":"A type of audit that combines financial records review with an assessment of internal IS controls."
  },
  {
     "key":269,
     "value":"integrated development environment (IDE)",
     "description":"An advanced software development tool used for writing programs. The IDE provides built-in functions for capturing the software design, commands, and macros for creating program code and debugging testing."
  },
  {
     "key":270,
     "value":"integrity",
     "description":"Unbiased honesty by a person dealing with other people or in the records of transactions."
  },
  {
     "key":271,
     "value":"interface",
     "description":"A specification of physical characteristics, electrical signals, format, and procedures used to communicate between systems."
  },
  {
     "key":272,
     "value":"internal audit",
     "description":"Internal audits are used to help the auditee improve their score. Reports from internal audits may be used only for internal purposes. The reports contain a known bias, which reduces their corresponding value of representations to low or moderate."
  },
  {
     "key":273,
     "value":"International Organization for Standardization (ISO)",
     "description":"A voluntary organization of 160 governments (members) participating in world trade. The objective is to create a universal standard of measurement adopted by each member country. The United States membership is represented by the American National Standards Institute (ANSI) while the United Kingdom is represented by British Standards (BS). Each country cooperates to create the proper conversion of proprietary standards into one worldwide ISO standard to be followed by everyone. ISO measurement standards are used in conjunction with Committee of Sponsoring Organizations (COSO) controls over financial transactions and Organization for Economic Cooperation and Development (OECD) standards for the creation and interpretation of laws within individual countries."
  },
  {
     "key":274,
     "value":"Internet",
     "description":"The shared public communications network."
  },
  {
     "key":275,
     "value":"Internet layer",
     "description":"The equivalent to OSI layer 3, the Network layer, in the TCP/IP model. See also Network Layer."
  },
  {
     "key":276,
     "value":"Internet Protocol (IP)",
     "description":"The de facto communications protocol and addressing standard used on the Internet. IP is implemented with TCP for connection-oriented data transmission or UDP for connectionless transmission."
  },
  {
     "key":277,
     "value":"interoperability",
     "description":"The ability for hardware and software systems from different manufacturers to communicate with each other. intranet A private internal business network."
  },
  {
     "key":278,
     "value":"intrusion detection and prevention system (IDPS)",
     "description":"A technical system designed to alert personnel to activity that may indicate the presence of a hacker. An intrusion detection system (IDS) is a type of network hacker alarm. The term IDS has been officially updated by the government to intrusion detection and prevention system (IDPS). Preprogrammed response procedures activate stored commands to modify the IDPS to block an attack before it can penetrate (prevention activity)."
  },
  {
     "key":279,
     "value":"intrusion detection system (IDS)",
     "description":"See intrusion detection and prevention system (IDPS) for updated terminology."
  },
  {
     "key":280,
     "value":"IPsec",
     "description":"A security-based implementation of the Internet Protocol. IPsec offers encryption during data transmission or the tunneling of encrypted packets through network routing with an ISP."
  },
  {
     "key":281,
     "value":"iris scan",
     "description":"A type of biometric technique that uses the unique characteristics found in the iris of the human eye."
  },
  {
     "key":282,
     "value":"irrelevant",
     "description":"Having no significant bearing on the final outcome. Irrelevant, or trivial, information will not change the results."
  },
  {
     "key":283,
     "value":"iterative development",
     "description":"The progressive development of software through a succession of multiple versions."
  },
  {
     "key":284,
     "value":"Java",
     "description":"A very portable object-oriented programming language created by Sun Microsystems. Java can run on cellular phones, iPods, and most computing devices. Java has very good security mechanisms."
  },
  {
     "key":285,
     "value":"Java Virtual Machine (JVM)",
     "description":"An internal processing environment for running a Java program inside of a Virtual Java Machine instance. The partitioning of resources creates a secure environment to protect the rest of the computer system from harm."
  },
  {
     "key":286,
     "value":"joint venture",
     "description":"Two or more obligators (persons or organizations) bind themselves without actual partnership or corporate designation in a specific venture with the risk, liability, and potential profits shared between the parties. All parties participating in the venture share a communal liability for the failure of the other parties."
  },
  {
     "key":287,
     "value":"just-in-time inventory (JIT)",
     "description":"A process of scheduling the minimum amount of inventory to arrive shortly before it is required in the manufacturing process. The objective is to reduce inventory on hand. The opposite of JIT is stockpiling inventory. JIT practices create a quandary with business continuity plans."
  },
  {
     "key":288,
     "value":"key distribution",
     "description":"The safe process of exchanging keys to be used in a cryptographic system for encryption and decryption."
  },
  {
     "key":289,
     "value":"key goal indicator (KGI)",
     "description":"The KGI identifies a specific goal to be reached. The KPI (historical score) is used together with the KGI (goal) in planning and forecasting."
  },
  {
     "key":290,
     "value":"key performance indicator (KPI)",
     "description":"A historical score of business process performance. Unfortunately, the score may indicate that a failure has occurred before corrective action can be taken."
  },
  {
     "key":291,
     "value":"key wrapping",
     "description":"Encryption keys must be stored and transmitted in a different encrypted format to protect them from harm. A user should not have direct access to encryption keys. Encryption keys are re-encrypted with a different algorithm that uses a different key to obscure the original key. This key wrapping technique protects the real key from harm. It\u0027s extremely difficult to tell where the wrapping stops and the key inside begins."
  },
  {
     "key":292,
     "value":"keyboard remapping",
     "description":"Changing the normal function of keys on the keyboard to execute different commands."
  },
  {
     "key":293,
     "value":"knowledge base",
     "description":"A database of information derived from the knowledge of individuals who perform the related tasks. Knowledge base systems are used for decision support systems."
  },
  {
     "key":294,
     "value":"leased line",
     "description":"A dedicated communications line between two locations, such as a T1 circuit. Also known as a circuit-switched connection. This type of connection is charged by distance covered regardless of volume of data transmitted."
  },
  {
     "key":295,
     "value":"least privilege",
     "description":"Granting only the minimum access necessary to perform the job function or role. Least privilege is implemented to improve confidentiality."
  },
  {
     "key":296,
     "value":"legal deadline (LD)",
     "description":"Used in business continuity and disaster recovery planning to identify potential violations that must be avoided or that require special handling to minimize penalties. Examples include mandatory government filings, required legal disclosures, specific performance, and contract breaches. Also see lost work in process ( LWIP)."
  },
  {
     "key":297,
     "value":"lessons learned",
     "description":"A best practice for recording the analysis of problems and improvements that worked. The purpose is to avoid repeating mistakes while improving the technique used."
  },
  {
     "key":298,
     "value":"local area network (LAN)",
     "description":"A computer network with boundaries that match the physical building."
  },
  {
     "key":299,
     "value":"logic bomb",
     "description":"A programmed function inside of a computer software application designed to damage the system or data files on the occurrence of a particular event, date, or time. Logic bombs are extremely difficult to locate."
  },
  {
     "key":300,
     "value":"logical access",
     "description":"Electronic access to a system, with no physical presence required."
  },
  {
     "key":301,
     "value":"logical backup",
     "description":"The process of copying current data files for records retention (safe keeping). Logical backup will ignore deleted files and temporary system data in swap space. Also see deleted files, swap space, and bitstream imaging."
  },
  {
     "key":302,
     "value":"lost work in process (LWIP)",
     "description":"Work tasks and data processing that were lost by a disaster, disruption, or failure. All work since the last backup is lost and must be re-created. LWIP may cause a violation of a legal deadline (LD). LWIP needs to be calculated by the organization when planning their recovery point objective (RPO) and recovery time objective (RTO). Also see legal deadline (LD), recovery point objective (RPO), and recovery time objective (RTO)."
  },
  {
     "key":303,
     "value":"mainframe",
     "description":"A large-scale, traditional, multiuser, multiprocessor system designed with excellent internal controls."
  },
  {
     "key":304,
     "value":"major software release",
     "description":"A new generation of software or a major design change resulting in a new version. Major releases tend to occur in 12- to 24-month intervals."
  },
  {
     "key":305,
     "value":"malware",
     "description":"A family classification of computer programs designed to intentionally cause malicious damage."
  },
  {
     "key":306,
     "value":"management oversight",
     "description":"A committee or reporting hierarchy to convey questionable situations involving management to the highest level of authority, often the board of directors."
  },
  {
     "key":307,
     "value":"mandatory access control (MAC)",
     "description":"An access control system based on rules that require the user to have an explicit level of access that matches the appropriate security label. The only way to increase access is by a formal promotion of the user ID to the next security level."
  },
  {
     "key":308,
     "value":"mantrap",
     "description":"A physical location between doorway barriers that is designed to trap an unauthorized individual between the closed doors. Fully caged turnstiles can provide a mantrap to capture potential intruders."
  },
  {
     "key":309,
     "value":"manual reconciliation",
     "description":"The process of manually verifying that records match."
  },
  {
     "key":310,
     "value":"manufacturing requirements planning (MRP)",
     "description":"A computer database designed to schedule the requirements of manufacturing design, purchasing, and the manufacturing production process."
  },
  {
     "key":311,
     "value":"masquerading",
     "description":"Pretending to possess an identity under false pretense."
  },
  {
     "key":312,
     "value":"materiality",
     "description":"Materiality applies to evidence. Evidence is materially significant if it will have enough bearing to change the final outcome."
  },
  {
     "key":313,
     "value":"maximum acceptable outage (MAO)",
     "description":"The longest period of downtime that an organization can survive from a specific outage involving a system, process, or resource."
  },
  {
     "key":314,
     "value":"maximum tolerable downtime (MTD)",
     "description":"Synonym for maximum acceptable outage (MAO), used as a negative connotation. Also see maximum acceptable outage (MAO)."
  },
  {
     "key":315,
     "value":"Media Access Control (MAC) address",
     "description":"A unique serial number burned into the network interface card by the manufacturer. The Media Access Control (MAC) address operates in the Data-Link layer (layer 2) of the OSI model. The MAC address is used to tie the TCP/IP address to a particular computer."
  },
  {
     "key":316,
     "value":"meshed network",
     "description":"Connection of redundant links."
  },
  {
     "key":317,
     "value":"message digest",
     "description":"A hash file of a fixed length created by a source file of any length. The purpose of the message digest is to indicate whether the source file has changed."
  },
  {
     "key":318,
     "value":"message modification",
     "description":"The alteration of a message to change its contents."
  },
  {
     "key":319,
     "value":"methodology",
     "description":"A systematic process of procedures to generate a desired outcome."
  },
  {
     "key":320,
     "value":"metropolitan area network (MAN)",
     "description":"A type of limited-area network in which the boundary is equal to the city\u0027s metropolitan area."
  },
  {
     "key":321,
     "value":"middleware",
     "description":"All software programs, interfaces, and utilities that operate invisibly between the user and their data. Middleware performs an intermediary service to create an invisible workflow connecting various programs. Examples include the database application running on your server, SQL/ODBC drivers, print formatting utilities, communication gateways, operating system, and all device drivers."
  },
  {
     "key":322,
     "value":"minor software update",
     "description":"Small corrective update issued by the software developer to fix problems found in a major version previously released. Also known as a software patch or minor software release. Also see major software release."
  },
  {
     "key":323,
     "value":"minutia",
     "description":"Biometric data representing specific characteristics that are unique to each user."
  },
  {
     "key":324,
     "value":"mirrored",
     "description":"Duplicate or redundant components operating in parallel."
  },
  {
     "key":325,
     "value":"multicast",
     "description":"To transmit data across the network to several specific stations concurrently."
  },
  {
     "key":326,
     "value":"multiprocessing",
     "description":"Using multiple processors."
  },
  {
     "key":327,
     "value":"multitasking",
     "description":"Running multiple tasks concurrently in a time-sharing mode by allocating a specific amount of resources to each task."
  },
  {
     "key":328,
     "value":"multithreading",
     "description":"Running several instances of a program concurrently for multiple users."
  },
  {
     "key":329,
     "value":"netmask",
     "description":"An overlay setting used to parse the IP address into two distinct portions representing the unique network address and unique host address. Without this setting, the computer will be confused and unable to communicate on the network."
  },
  {
     "key":330,
     "value":"network based",
     "description":"A hardware or software device that is watching the communications traffic flowing across the network to other systems."
  },
  {
     "key":331,
     "value":"Network File System (NFS)",
     "description":"A method of sharing disk systems across the network by using remote procedure calls. NFS was invented by Sun Microsystems to share hard disks with multiple users across the network."
  },
  {
     "key":332,
     "value":"network hub",
     "description":"An OSI layer 1 device designed to relay electrical transmissions and receive signals between computers."
  },
  {
     "key":333,
     "value":"Network layer",
     "description":"Layer 3 of the OSI model. The Network layer is responsible for network addressing and routing."
  },
  {
     "key":334,
     "value":"network monitoring",
     "description":"The process of monitoring communications, traffic, performance, and events by using a packet analyzer (sniffer), Simple Network Management Protocol (SNMP), and the Remote Monitoring Protocol (RMON). Also see Simple Network Management Protocol."
  },
  {
     "key":335,
     "value":"network switch",
     "description":"An intelligent bridge running on OSI layer 2. The network switch converts shared traffic from all ports into filtered discrete traffic for an individual port. The purpose is to reduce network congestion by eliminating traffic that does not involve the specific station."
  },
  {
     "key":336,
     "value":"neural network",
     "description":"A type of decision-making system that uses weights and the simulation of human synapses to make a decision."
  },
  {
     "key":337,
     "value":"nondiscretionary access control",
     "description":"A method of access control based on job role and required tasks."
  },
  {
     "key":338,
     "value":"nonrepudiation",
     "description":"A technical process designed to eliminate the opportunity for a person to reject or renounce their participation. Intended to protect the recipient from claims of denial by the other party."
  },
  {
     "key":339,
     "value":"nonvolatile data",
     "description":"Persistent data retained on the hard disk and other storage media after system shutdown."
  },
  {
     "key":340,
     "value":"normalization",
     "description":"The process of removing duplicate, redundant data from a database."
  },
  {
     "key":341,
     "value":"object",
     "description":"In object-oriented programming, the program object contains both data and procedural methods. Program objects are able to delegate to other program objects."
  },
  {
     "key":342,
     "value":"object class",
     "description":"An administrative grouping of program objects with similar attributes or related behavior. Similar to the classification of insects by their shared attributes or classification of manned spacecraft versus unmanned spacecraft. Programming objects are classified by similarity of their attributes and operating methods."
  },
  {
     "key":343,
     "value":"object code",
     "description":"The machine-executable instructions that are output from the programmer\u0027s compiling process. Object code is designed to run on the computer and is unreadable to humans."
  },
  {
     "key":344,
     "value":"objective",
     "description":"A specific goal or target."
  },
  {
     "key":345,
     "value":"objectivity",
     "description":"Impartiality, fairness. This term is used in relation to fair and unbiased information used in an audit. An auditor who acts in a manner that is fair and unbiased and has objectivity."
  },
  {
     "key":346,
     "value":"object-oriented database (OODB)",
     "description":"A database designed for data with an unknown format and structure. OODB is very flexible and may be quite complex. OODB is good for organizing information such as MP3 files with photographic images and other programs as items inside the database."
  },
  {
     "key":347,
     "value":"open system",
     "description":"Software that is readily available because nonproprietary programming methods are used in its design. The recipient receives the human-readable source code with the ability to make any internal changes they desire. An open system can exchange data with a closed system by using a specific application programming interface (API). The Apache web server, Linux operating system, OpenOffice.org application, and SugarCRM software are examples of open systems. Also see source code, closed system, and application programming interface (API)."
  },
  {
     "key":348,
     "value":"Open Systems Interconnection (OSI)",
     "description":"An international reference model used to explain the functions in network communications."
  },
  {
     "key":349,
     "value":"operating system (OS)",
     "description":"A computer software program that interfaces between hardware devices and the user\u0027s application. Operating systems provide the coordination of resources and the user interface."
  },
  {
     "key":350,
     "value":"operational audit",
     "description":"A type of audit that reviews the internal controls used in daily operation."
  },
  {
     "key":351,
     "value":"Organization for Economic Cooperation and Development (OECD)",
     "description":"A voluntary organization of governments participating in world trade. OECD provides the framework of laws and interpretations for each country to adopt in support of world trade. Since 1992, the OECD guidelines serve as an agreed-upon reference for a total information security framework. OECD guidelines are used in conjunction with Committee of Sponsoring Organizations (COSO) for financial controls and international standards of measurement provided by the International Organization for Standardization (ISO)."
  },
  {
     "key":352,
     "value":"output controls",
     "description":"A combination of physical and administrative controls used to protect the confidentiality of system output. Examples of output controls include report distribution lists and physical security of specialized output such as payroll checks."
  },
  {
     "key":353,
     "value":"outsourcing",
     "description":"The contractual arrangement to transfer ongoing operations to an external service provider."
  },
  {
     "key":354,
     "value":"packet replay",
     "description":"An attack that replays a series of previously recorded legitimate network messages in an attempt to fool the recipient into believing that the attacker is a legitimate user."
  },
  {
     "key":355,
     "value":"packet switching",
     "description":"A method of transmitting data through a variety of different paths en route to its destination. The user is billed by the data packets sent and not the route or distance traveled."
  },
  {
     "key":356,
     "value":"packet-filtering firewall",
     "description":"A primitive type of network firewall that filters traffic based on source and destination addresses."
  },
  {
     "key":357,
     "value":"paper test",
     "description":"A desktop review of printed documentation."
  },
  {
     "key":358,
     "value":"parallel testing",
     "description":"Running two systems in parallel to verify the integrity of transactions and minimize risk during the system migration process."
  },
  {
     "key":359,
     "value":"passive attack",
     "description":"Eavesdropping and other covert techniques used to collect information."
  },
  {
     "key":360,
     "value":"password",
     "description":"A short sequence of characters used in single-factor (weak) authentication. Most user passwords are six to eight characters in length. Passwords should be changed every 30 to 90 days. The password itself should not be a word printed in any language but instead a set of alphanumeric characters that is memorable to the user."
  },
  {
     "key":361,
     "value":"patch",
     "description":"See minor software update."
  },
  {
     "key":362,
     "value":"patch management",
     "description":"A planned method of testing and tracking minor software updates prior to implementation in production. Minor updates (or patches) are known to have unexpected consequences that can alter or disable other controls. All changes should be installed in a separate test environment, and regression testing should occur before being installed in production. The cost of separate testing can be justified by using the price of failure (price of nonconformance). See also minor software updates, regression testing, and price of noncomformance (PONC)."
  },
  {
     "key":363,
     "value":"patent",
     "description":"A public record of a unique design or function to which the author/inventor is granted exclusive rights for a limited period of time. Patents require the inventor to furnish a complete and functional blueprint of the design for anyone to reproduce a working replica with the exact same functionality. This is why intellectual trade secrets shall never be patented. Future patent applicants must show how their new design does not infringe on existing patents. Also see trade secret."
  },
  {
     "key":364,
     "value":"Plan-Do-Check-Act (PDCA) cycle",
     "description":"Walter Shewhart\u0027s quality planning cycle of Plan, Do, Check, Act. The PDCA model may be mistakenly referred to as the Deming PDCA cycle because W. Edwards Deming was a student of Shewhart. Origins of PDCA date back to Alexander the Great of Macedonia."
  },
  {
     "key":365,
     "value":"penetration testing",
     "description":"A type of test designed to gauge possible penetration through the system security mechanisms by exploiting known vulnerabilities. Penetration testing should be conducted only under the supervision of software quality control technicians or trained auditors with formal approval of executive management. Separation of duties must be enforced."
  },
  {
     "key":366,
     "value":"persistent electronic threat",
     "description":"Continuous threat of breach through electronic attacks. A hacker can commit the crime at a safe distance without fear of physical capture. Attacks may originate from self-directed hackers anywhere in the world. Well-organized attacks are known to be sponsored by a foreign government to gather intelligence data."
  },
  {
     "key":367,
     "value":"pervasive controls",
     "description":"Specific mid-level controls over any technology shared across multiple departments. IT systems exist in almost all departments, and therefore IT-type controls must also exist in each department regardless of who is in charge."
  },
  {
     "key":368,
     "value":"phishing",
     "description":"A social engineering technique designed to trick the user into divulging confidential information such as user ID, password, bank account information, and Social Security number. Also see spear-phishing."
  },
  {
     "key":369,
     "value":"physical control",
     "description":"A type of control implemented by using barriers to prevent unauthorized access."
  },
  {
     "key":370,
     "value":"Physical layer",
     "description":"The lowest layer of the OSI model; it deals with physical cabling and electrical signals."
  },
  {
     "key":371,
     "value":"ping test",
     "description":"Submarines detect other objects by using a single broadcast transmission and waiting for the sound reflection (ping) to bounce back. Similarly, computers use ping commands on the network to request that all machines on the same subnet respond with a ping-reply transmission."
  },
  {
     "key":372,
     "value":"policy",
     "description":"A high-level statement by management specifying an objective that requires mandatory compliance for all persons of lower authority."
  },
  {
     "key":373,
     "value":"portfolio management",
     "description":"Selecting projects based on the principles of \u0022highest and best use\u0022 of available resources for generating the best return on investment (ROI). Projects are selected or canceled according to which ones will generate the best return under the current circumstances. Similar to trading stock investments or baseball cards to improve the overall value of your collection."
  },
  {
     "key":374,
     "value":"postimplementation review",
     "description":"A review of the system after it is placed in operation to determine whether it has fulfilled its original objectives. New objectives may be identified that require the system to be modified to attain compliance with the new requirements."
  },
  {
     "key":375,
     "value":"Presentation layer",
     "description":"This layer of the OSI model deals with screen formatting and display properties. The Presentation layer is also known as OSI layer 6."
  },
  {
     "key":376,
     "value":"preventative control",
     "description":"A type of control that seeks to stop a particular type of event from occurring. Preventative controls may be implemented by using administrative methods, technical methods, and physical methods."
  },
  {
     "key":377,
     "value":"price of conformance (POC)",
     "description":"The cost savings for doing it right the first time. Proper training and planning is a POC expense that conserves money and time by avoiding the additional costs of failure."
  },
  {
     "key":378,
     "value":"price of nonconformance (PONC)",
     "description":"Represents the added costs of failure for not doing it right the first time. Added costs include penalties, redoing work, and uncompensated warranty repair. PONC usually exceeds the original profit margin."
  },
  {
     "key":379,
     "value":"primary key",
     "description":"A unique entry into a database record that is required for the record to be valid. The primary key for user information might be the login ID. Without the login ID, the user\u0027s details would be invalid. Primary keys can be user ID numbers to prevent conflicts from using last names for people. Last names can change as users get married or divorced."
  },
  {
     "key":380,
     "value":"Private Branch Exchange (PBX)",
     "description":"The telephone switch that creates virtual private extensions for the users in the organization. The telephone switch is a technology resource that must be protected from hackers."
  },
  {
     "key":381,
     "value":"private key",
     "description":"A file used as a randomizer in encryption algorithms. The private key must be kept secret from all other users in order to protect the confidentiality of encrypted files."
  },
  {
     "key":382,
     "value":"procedure",
     "description":"A mandatory set of steps used as a cookbook recipe for a desired result. Procedures provide the day-to-day low-level execution necessary to support a standard."
  },
  {
     "key":383,
     "value":"process audit",
     "description":"Evaluating the process method by measuring the inputs, sequence of activities, and output to determine whether the process meets the published requirements (specifications)."
  },
  {
     "key":384,
     "value":"product audit",
     "description":"Checks the product attributes against design specifications to determine whether the product meets the intended requirements. Attributes may include connectivity features, audit logging, security controls, and the quality of documentation."
  },
  {
     "key":385,
     "value":"Program Evaluation Review Technique (PERT)",
     "description":"A project management technique used to determine the critical path and to forecast the time and resources necessary to complete the most important elements of a specific project."
  },
  {
     "key":386,
     "value":"program management",
     "description":"Managing a series of individual projects to create an ongoing operation, also known as a functional support program. Examples include maintenance, customer service, auditing for annual compliance, and new product development."
  },
  {
     "key":387,
     "value":"project management",
     "description":"A management methodology used to plan and control the execution of a unique project to maximize its outcome based on limitations of time, resources, and scope."
  },
  {
     "key":388,
     "value":"protection profile (PP)",
     "description":"A defined list of testing objectives applicable to the intended use of the system under evaluation (target of evaluation, or TOE). Different protection profiles exist in the Common Criteria (ISO 15408) depending on whether the system\u0027s role will be as a workstation, file server, database, or security device. Also see target of evaluation (TOE) and Common Criteria."
  },
  {
     "key":389,
     "value":"protocol",
     "description":"A formal specification of rules for interfaces and procedures used in communication."
  },
  {
     "key":390,
     "value":"protocol stack",
     "description":"Different layers of services provided inside a communication protocol, also known as stack of protocol services."
  },
  {
     "key":391,
     "value":"prototyping",
     "description":"A system development technique used to create initial versions of software functionality. The prototype is focused on proving a method or gaining early user acceptance. Prototypes seldom have any internal controls."
  },
  {
     "key":392,
     "value":"provisioning",
     "description":"Administrative process of dividing services for allocation to the user."
  },
  {
     "key":393,
     "value":"proxy firewall",
     "description":"A type of firewall that prevents direct access to network resources. The user request is rerouted through a proxy application that will filter the request for security compliance and present the filtered request to the desired application on behalf of the user."
  },
  {
     "key":394,
     "value":"pseudocode",
     "description":"A set of commands and macros developed into a custom template inside of an integrated development environment (IDE) programming tool. The software engineer designs the structure and function of the software inside the IDE for ease and maintainability. The IDE tool converts the pseudocode into actual programming code for the machine to use. Most fourth-generation programming tools use pseudocode templates to write programs. Also see integrated development environment (IDE)."
  },
  {
     "key":395,
     "value":"public key",
     "description":"A variable used in the encryption algorithm that is mathematically related to the private key. The public key is freely distributed by the sender to parties interested in communicating with the sender. A sender and recipient would exchange public keys in order to encrypt the files for transmission."
  },
  {
     "key":396,
     "value":"public-key interchange (PKI)",
     "description":"See asymmetric-key encryption."
  },
  {
     "key":397,
     "value":"qualified opinion",
     "description":"The auditor has placed restrictions on the nature, use, or content of their findings. The audit may have encountered problems in scope, time, thoroughness of tests, or content of available evidence. Also see unqualified opinion."
  },
  {
     "key":398,
     "value":"quality",
     "description":"Development of well-defined specifications while ensuring adherence to those specifications. Quality is created in the planning and design phases, not by postinspection. Quality provides a cost savings when compared to the added costs of failure (price of nonconformance). Also see price of nonconformance."
  },
  {
     "key":399,
     "value":"quality assurance (QA)",
     "description":"A process of measurement standards designed to ensure product integrity."
  },
  {
     "key":400,
     "value":"quality control (QC)",
     "description":"The process of planning, testing, and reviewing to ensure that the product meets the minimum acceptable performance specifications (level of quality)."
  },
  {
     "key":401,
     "value":"radio frequency identification (RFID)",
     "description":"Insecure method of reading radio signals to identify products, people, or physical items. Any RFID tag that can be read can also be duplicated."
  },
  {
     "key":402,
     "value":"Rapid Application Development (RAD)",
     "description":"A software development methodology that automates portions of the SDLC process. RAD does not provide the enterprise-level requirements planning necessary for a business system. RAD is designed to speed coding time by using smaller software modules."
  },
  {
     "key":403,
     "value":"reciprocal agreement",
     "description":"An agreement between two parties to help each other in the event of a disaster. Most reciprocal agreements are ineffective and unenforceable. The concept is popular because it does not bear any direct cost to either party. The reciprocal agreement ignores inherent conflicts that exist between two organizations. An exception exists regarding cooperative ownership of hot sites between financial organizations."
  },
  {
     "key":404,
     "value":"records management",
     "description":"Collective process of classifying information to ensure proper safeguards and control with the goal of providing complete integrity. Records must be created, labeled for proper handling, kept in safe storage, have controlled distribution, and ultimately be retired with proper disposal. Records of real property transactions are required to be kept forever. All record management and criminal penalties are judged by comparison to the ISO 15489 standard for records management."
  },
  {
     "key":405,
     "value":"recovered work in process (RWIP)",
     "description":"Work tasks and data processing interrupted by a disaster or system failure. Recovered work is reprocessed according to the designated recovery time objective (RTO). Also see recovery time objective (RTO)."
  },
  {
     "key":406,
     "value":"recovery point objective (RPO)",
     "description":"Refers to a point in time to which the loss of data is acceptable. This means that work in progress since the last data backup will be lost."
  },
  {
     "key":407,
     "value":"recovery time objective (RTO)",
     "description":"The estimated time to recover a system based on the organization\u0027s capabilities and maximum acceptable outage."
  },
  {
     "key":408,
     "value":"Redundant Array of Independent Disks (RAID)",
     "description":"A technical method of providing redundant disk storage space by using multiple disk drives. Previously known as Redundant Array of Inexpensive Disks until hardware vendors discovered the opportunity for a price increase."
  },
  {
     "key":409,
     "value":"referential integrity",
     "description":"When information contained in two or more data tables is valid across the links inside the database (foreign key relationship). A failure of referential integrity indicates a failed program or corrupt database. Also see foreign-key."
  },
  {
     "key":410,
     "value":"registration authority (RA)",
     "description":"A delegated representative of the certificate authority (CA) with the ability to issue a valid digital certificate. For example, a travel agent is the registration authority for selling airline tickets. The airline is the certificate-issuing authority and issues an electronic ticket (a type of digital certificate). Also see certificate authority (CA) and digital certificate."
  },
  {
     "key":411,
     "value":"regression testing",
     "description":"The process of retesting a system after changes to ensure that the changes do not create any additional undesired complications."
  },
  {
     "key":412,
     "value":"regulatory controls",
     "description":"Controls placed on industry by the government."
  },
  {
     "key":413,
     "value":"relational database structure",
     "description":"A type of database that splits information between multiple tables while maintaining a link between the data for related entries. A relational database keeps a relationship between different data elements."
  },
  {
     "key":414,
     "value":"remote access server (RAS)",
     "description":"A service that provides security and authentication for remote users."
  },
  {
     "key":415,
     "value":"Remote Procedure Call (RPC)",
     "description":"A program method in client/server computing that allows a computer to request services from another computer without having to develop specific procedures for each program."
  },
  {
     "key":416,
     "value":"residual risk",
     "description":"The amount of risk that remains after all controls have been implemented and mitigation efforts have been completed."
  },
  {
     "key":417,
     "value":"retina scan",
     "description":"A biometrics technique that maps the unique pattern of veins in the back of the human eyeball."
  },
  {
     "key":418,
     "value":"revenue objective (RO)",
     "description":"Used in business continuity planning to demonstrate the minimum revenue necessary for survival at various stages of recovery. Also used in business process reengineering as a claim of the expected benefit for reengineering a process."
  },
  {
     "key":419,
     "value":"reverse engineering",
     "description":"An engineering technique used to steal the secrets of a competitor for the purpose of developing your own product. Reverse engineering is usually a violation of the software user license agreement."
  },
  {
     "key":420,
     "value":"right to audit",
     "description":"The contractual rights of an organization to audit a third-party service provider. The right to audit must be clearly defined in the contract along with the expected terms of the audit."
  },
  {
     "key":421,
     "value":"ring topology",
     "description":"A networking topology that creates two paths between the senders and receivers. The most common implementation is an IBM Token Ring for a local area network. The public telephone company uses a fiber ring topology for a redundant connection between central offices."
  },
  {
     "key":422,
     "value":"risk",
     "description":"The likelihood that an unfortunate event will occur and cause a loss of assets."
  },
  {
     "key":423,
     "value":"risk assessment",
     "description":"The process of reviewing risks, threats, and vulnerabilities to determine appropriate controls."
  },
  {
     "key":424,
     "value":"risk management",
     "description":"The process of assessing risks in determining the organization\u0027s response. Acceptable responses could be mitigation, avoidance, acceptance, or transference."
  },
  {
     "key":425,
     "value":"risk-based audit",
     "description":"The technique to determine the high-risk areas of an organization. Priority would be given to audit the high-risk areas first, before low-risk areas."
  },
  {
     "key":426,
     "value":"robot network",
     "description":"See bot-net."
  },
  {
     "key":427,
     "value":"Robust Security Network (RSN)",
     "description":"A new 802.11i standard for security on wireless networks (2005). Mandated by the US government to replace network equipment using the outdated and insecure Wired Equivalent Privacy (WEP) method of preshared encryption keys. RSN uses Extensible Authentication Protocol (EAP) with temporal keys and port-based access control. Also see Wired Equivalent Privacy and Extensible Authentication protocol (EAP)."
  },
  {
     "key":428,
     "value":"role-based access control (RBAC)",
     "description":"A type of nondiscretionary access control based on job duties."
  },
  {
     "key":429,
     "value":"root kit",
     "description":"A malicious hacker program designed to unsuspectingly install a backdoor without the consent of the system user. A root kit will subvert the operating system kernel security and operate in stealth to hide its existence. Normal system utilities are usually unable to detect the presence of a root kit."
  },
  {
     "key":430,
     "value":"router",
     "description":"A networking device that uses traffic routing to forward a message to its intended destination. Network routers operate on OSI layer 3."
  },
  {
     "key":431,
     "value":"routing protocol",
     "description":"The procedure and formula used to direct communications across the available path. Static routing will always follow the same path. Dynamic routing will use a formula of metrics to redirect communications along the best available route at the present time."
  },
  {
     "key":432,
     "value":"run-to-run totals",
     "description":"A process that tracks the total number of submissions to ensure that all transactions have been processed."
  },
  {
     "key":433,
     "value":"scenario approach",
     "description":"Planning exercises center around solving the problems presented in a simulated event (scenario). This lends a credible purpose bearing on reality in the exercise. Scenario exercises are used in planning to uncover previous assumptions and interesting quirks used in the decision process. Assumptions may no longer be valid. You may discover additional defects in the decision criteria."
  },
  {
     "key":434,
     "value":"screened host",
     "description":"A single computer host protected by a firewall and accessible by both internal and external users."
  },
  {
     "key":435,
     "value":"screened subnet",
     "description":"A subnet of multiple computer hosts protected by a firewall and accessible by both internal and external users. A screened subnet is also known as a demilitarized zone (DMZ). War veterans will tell you that you can still get killed in a demilitarized zone."
  },
  {
     "key":436,
     "value":"script kiddies",
     "description":"Individuals who execute scripted programs or utilities without comprehensive knowledge of the internal mechanisms being executed. For example, I am a script kiddy every time I run a macro or setup script that I didn\u0027t write. The term also refers to novice hackers using automated attack tools downloaded from the Internet."
  },
  {
     "key":437,
     "value":"Secure Shell (SSH)",
     "description":"An encrypted terminal session providing additional security for the user."
  },
  {
     "key":438,
     "value":"Secure Sockets Layer (SSL)",
     "description":"Session-layer security and encryption between a user and a server. SSL is a common form of security for virtual private networks (VPNs). This method uses private-key encryption with a digital certificate on the server."
  },
  {
     "key":439,
     "value":"security parameter index (SPI)",
     "description":"A security specification used in the header of the IPsec protocol to identify encryption keys used in communication."
  },
  {
     "key":440,
     "value":"security policy",
     "description":"A formal statement by management of the importance in implementing proper security controls. A second definition is a set of rules implemented to protect the organization."
  },
  {
     "key":441,
     "value":"security target (ST)",
     "description":"Security targets represent the chosen Common Criteria standard of performance acceptable from the system under evaluation (TOE). To fail this target would result in a lower assurance rating. Also see target of evaluation (TOE). Also see Common Criteria."
  },
  {
     "key":442,
     "value":"separation of duties",
     "description":"The separation of transaction authorization from other normal work activities. The purpose of separation or segregation of duties is to ensure that no changes are executed without being observed by another individual. The purpose of the control is to minimize fraud, error, and omission."
  },
  {
     "key":443,
     "value":"server mirroring",
     "description":"See mirrored."
  },
  {
     "key":444,
     "value":"service delivery objective (SDO)",
     "description":"The level of service to be available at a particular point in time. This may be full service for all users or service for a particular core process only."
  },
  {
     "key":445,
     "value":"service-level agreement (SLA)",
     "description":"A contractual agreement between the user and the service provider that outlines an acceptable level of support for business processing."
  },
  {
     "key":446,
     "value":"servlet",
     "description":"A web-based program that runs on the server; also known as a server-side include (SSI). This type of program does not download to the PC as an applet would. However, applets can access servlets for better performance by using distributed processing."
  },
  {
     "key":447,
     "value":"Session layer",
     "description":"Layer 5 of the OSI model, which manages service communication requests between systems."
  },
  {
     "key":448,
     "value":"shell",
     "description":"A technical name for the user\u0027s display session on the computer."
  },
  {
     "key":449,
     "value":"signature based",
     "description":"Term that describes a technical method that relies on the database of known software behavior. Signature files indicate a particular type of attack for virus protection or intrusion detection."
  },
  {
     "key":450,
     "value":"Simple Network Management Protocol (SNMP)",
     "description":"An automated process for managing devices across the network by transmitting remote commands with passwords. The SNMP passwords are referred to as community strings. The management value of SNMP is high, and security is usually very poor. If properly configured, SNMP version 3 contains some security, provided all the devices are using version 3 and not the older versions of 1 and 2. Running mixed versions of SNMP indicates a security failure. SNMP can remotely reconfigure or reboot a device."
  },
  {
     "key":451,
     "value":"Simple Network Management Protocol (SNMP) console",
     "description":"A dedicated system used by IT operations to actively monitor all the SNMP alerts generated by all the network devices. Examples include the original HP OpenView and open network management system (OpenNMS). IS security usually has its own SNMP monitoring console for separation of duties."
  },
  {
     "key":452,
     "value":"single sign-on (SSO)",
     "description":"A technical method that uses encryption to allow the user to simultaneously log in to all the network servers. The objective is to increase security with stronger passwords and to make the network easier for the user. Unauthorized access under single sign-on may allow the compromise of all network resources."
  },
  {
     "key":453,
     "value":"single-factor authentication",
     "description":"A type of authentication that uses passwords alone or tokens alone to authenticate a user. There is no real assurance that the user is the intended party. Single-factor authentication is known as weak authentication regardless of the constructive strength of passwords used. The password indicates only that somebody known or unknown has logged in by using that password string."
  },
  {
     "key":454,
     "value":"skills matrix",
     "description":"An administrative planning tool used to ensure that each task is assigned to the right person with the correct skills. Data in the matrix will demonstrate skill gaps and help justify training needs. This discourages the assignment of untrained personnel (or any warm body)."
  },
  {
     "key":455,
     "value":"slack space",
     "description":"Refers to the difference between space currently used by files and the remnant space previously allocated on a hard disk. Slack space is the leftover space that may contain old deleted data that has not yet been overwritten."
  },
  {
     "key":456,
     "value":"sniffer",
     "description":"A packet analyzer that can decode data transmissions across the network. A sniffer can also display passwords in transit."
  },
  {
     "key":457,
     "value":"SOAP",
     "description":"Used in XML programming to define the application programming interface (API) being used. Originally known as Simple Object Access Protocol. Also see application programming interface."
  },
  {
     "key":458,
     "value":"sociability testing",
     "description":"Software tests to determine how well a program can operate with other programs (social behavior)."
  },
  {
     "key":459,
     "value":"social engineering",
     "description":"The process of gaining access by tricking a user into cooperating. sockets Special software buffer used for communication between programs across the network."
  },
  {
     "key":460,
     "value":"software as a service (SaaS)",
     "description":"Online vendor provides the use of commercial software through subscription agreement. Software is hosted and supported remotely for the benefit of the subscriber and their users. This is simply a name variation of an outsource service bureau, application service provider (ASP), or productivity software supplied via cloud computing."
  },
  {
     "key":461,
     "value":"software baseline",
     "description":"A document recording all the design features agreed to be included in the software. Progress and changes are reported against this baseline to indicate actual performance in the development phase. Any variance in the development needs to be approved by the user and management."
  },
  {
     "key":462,
     "value":"source code",
     "description":"The original version of computer programs that are still in human-readable form. Programmers write program in source code. The source code is fed into a compiler that generates object code to run on the machine. Source code needs to be protected for integrity. The source code represents the original set of instructions and a tremendous amount of work."
  },
  {
     "key":463,
     "value":"source lines of code (SLOC)",
     "description":"An older style of estimating the complexity of a program or of measuring progress of new development. SLOC is still used in software estimation. The value of this calculation is lost whenever you combine the SLOC count from different generations of programming tools."
  },
  {
     "key":464,
     "value":"source routing",
     "description":"An old diagnostic protocol that allows the sender to specify the communications path to be used in spite of the network router settings configured by the network administrator. Source routing can circumvent firewalls and should be disabled on network devices."
  },
  {
     "key":465,
     "value":"spamming",
     "description":"Replying to more people than necessary when you respond to an email message (also known as email flaming). It also refers to sending a large number of unsolicited email messages. Sending unsolicited commercial email advertisements is usually legal if the sender is fully identified and offers a working mechanism for the recipient to opt out of (stop receiving) future messages. Opt-out may be automated or offer the option of using a manual process."
  },
  {
     "key":466,
     "value":"spear-phishing",
     "description":"Very effective attack technique used to target a specific system. This attack targets an individual server, user, database, or network device."
  },
  {
     "key":467,
     "value":"spiral model",
     "description":"A software development planning model that demonstrates the life cycle for multiple versions of software."
  },
  {
     "key":468,
     "value":"split horizon",
     "description":"A network routing algorithm used to prevent communication loops by breaking the loop through the creation of an artificial horizon. Similar to the concept of creating the earth\u0027s international dateline."
  },
  {
     "key":469,
     "value":"spoofing",
     "description":"Committing fraud by masquerading as a legitimate user or another system."
  },
  {
     "key":470,
     "value":"SQL injection",
     "description":"One computer program sends data as input to another program operated by someone else, with or without their permission. SQL injection techniques represent the most common method of integrating between programs, especially e-commerce across the Internet. SQL injection is possible due to input authentication failure by the receiving program. Using strong cryptographic controls instead of passwords is one method to discourage unauthorized SQL injection."
  },
  {
     "key":471,
     "value":"standard",
     "description":"Specifies a minimum level of mandatory compliance to ensure uniform consistency with integrity. Also see integrity."
  },
  {
     "key":472,
     "value":"standing data",
     "description":"Information stored on the hard disk and other storage media. This information is \u0022standing still\u0022 on the media and susceptible to attack, disclosure, or compromise."
  },
  {
     "key":473,
     "value":"star topology",
     "description":"Uses a dedicated connection from the hub/switch to each node on the network. Star topology is the most flexible topology and has a higher cost due to the redundant use of cabling."
  },
  {
     "key":474,
     "value":"stateful packet inspection",
     "description":"The technique used in third-generation firewalls to maintain a table of session connections that include connectionless communications; the table of session connections is also referred to as the state. Communication requests are monitored against the table to ensure that the request is in character with the transaction and is not a hacking attempt."
  },
  {
     "key":475,
     "value":"Statements on Auditing Standards (SAS)",
     "description":"A list of accounting standards put forth by the American Institute of Certified Public Accountants."
  },
  {
     "key":476,
     "value":"stop-and-go sampling",
     "description":"A simple test used to prove that the likelihood of errors is low. It is used when errors are expected and allows the auditor to stop at the earliest possible opportunity."
  },
  {
     "key":477,
     "value":"storage area network (SAN)",
     "description":"A special type of network used to connect various storage devices to servers. Storage area networks are usually attached by fiber optics."
  },
  {
     "key":478,
     "value":"strategic objective",
     "description":"Describes a fundamental method or change used to direct the organization toward an objective. Strategic objectives are usually in a time frame of three to five years."
  },
  {
     "key":479,
     "value":"strong authentication",
     "description":"See two-factor authentication."
  },
  {
     "key":480,
     "value":"subject",
     "description":"The target of the audit or control mechanism."
  },
  {
     "key":481,
     "value":"subnet",
     "description":"A small group of computers and devices sharing the same broadcast domain. Subnets are connected to larger networks via routers. Also known as a subnetwork."
  },
  {
     "key":482,
     "value":"substantive testing",
     "description":"A type of test that seeks to verify content and its integrity. Substantive tests include verifying count balances and performing physical inventory counts. Technical methods include executing detailed system scans to detect the effectiveness of a particular security configuration."
  },
  {
     "key":483,
     "value":"swap space",
     "description":"A special area on the hard disk designated as a temporary location for data to be \u0022swapped\u0022 out of RAM (electronic working memory). This improves system performance by moving selected tasks out of the way while other data is processed. Also known as virtual memory."
  },
  {
     "key":484,
     "value":"switch",
     "description":"See network switch."
  },
  {
     "key":485,
     "value":"symmetric-key encryption (secret key)",
     "description":"An encryption algorithm that uses a secret key shared between the sender and the receiver. Symmetric-key encryption systems are time sensitive and will operate only while both ends are using the same key. Symmetric-key systems are faster than asymmetric encryption because the key does not have to be derived through mathematical calculation."
  },
  {
     "key":486,
     "value":"syslog",
     "description":"A program designed to send system event logs to a remote system log server (also known as syslogging). A copy of all the log events is safely stored on a separate server. Log files are protected from the attacker, and the extra copy of log files enforces separation of duties."
  },
  {
     "key":487,
     "value":"system audit",
     "description":"Evaluates the management of a system, including its configuration. The purpose is to determine how well the system is managed by collecting evidence indicating its specific configuration settings."
  },
  {
     "key":488,
     "value":"System Development Life Cycle (SDLC)",
     "description":"A series of seven phases that represent the life cycle of software development. The phases are as follows: feasibility study, requirements definition, system design, development, implementation, postimplementation, and disposal."
  },
  {
     "key":489,
     "value":"Systems Network Architecture (SNA)",
     "description":"Early hierarchical design created by IBM for connecting different computers."
  },
  {
     "key":490,
     "value":"tactical",
     "description":"Describes the application of a procedure or method, hopefully in support of an organizational objective."
  },
  {
     "key":491,
     "value":"target of evaluation (TOE)",
     "description":"A computer system or network device to be evaluated under the Common Criteria standard (ISO 15408). Also see protection profile (PP) and security target (ST). Also see Common Criteria."
  },
  {
     "key":492,
     "value":"TCP/IP",
     "description":"Transmission Control Protocol running on the Internet Protocol. This has become synonymous with the Internet Protocol and accessing data across the network. Transmission Control Protocol is used for connection-oriented sessions on the Internet."
  },
  {
     "key":493,
     "value":"temporal key",
     "description":"A temporary and uniquely generated encryption key. Also see Robust Security Network (RSN)."
  },
  {
     "key":494,
     "value":"threat",
     "description":"A potential danger that, if realized, will have a negative effect on assets."
  },
  {
     "key":495,
     "value":"throughput",
     "description":"Effective speed metric for processing a complete set of specific transactions. Overall throughput speed usually varies according to the input, processing, and output requirements of particular transactions."
  },
  {
     "key":496,
     "value":"time bomb",
     "description":"Instructions written by the programmer in computer software to disable the functionality of the program based on a specific date or event. Time bombs are used by programmers to disable evaluation periods, force license upgrades, or cause damage on a particular date such as April Fools\u0027 Day."
  },
  {
     "key":497,
     "value":"top-down structured programming",
     "description":"Methodically breaking down high-level functions into an orderly design of smaller distinct program modules. Individual modules perform unique functions and can be updated or replaced with relative ease. Modules are linked together to form the finished program. In top-down programming, more time is spent on formal planning of functional specifications than on code development."
  },
  {
     "key":498,
     "value":"tort damage",
     "description":"An injury or wrong inflicted upon another party and created by a violation of duty. It can be created by deprivation of a legal right, by violation of a private obligation with or without a contract, or by infraction of a duty to the public. Special damages will accrue. Examples of tort injuries or wrongs include negligence or breach of an agreement in bad faith. The victim may be eligible for up to 20 times the actual damages."
  },
  {
     "key":499,
     "value":"trade secret",
     "description":"A unique process, tool, formula, pattern, or knowledge possessed by its creator and hidden from everyone else for the purpose of obtaining an advantage in the market. The owner must provide extensive protection to prevent disclosure or risk forfeiting their claim. Trade secrets cannot be patented."
  },
  {
     "key":500,
     "value":"traffic analysis",
     "description":"A technique used by an intruder to monitor communications and determine the most significant systems on the network. The objective is to build a map of network devices to be used for launching future attacks."
  },
  {
     "key":501,
     "value":"transaction processing (TP) monitor",
     "description":"A software process that monitors the performance and health of the hardware running a database application. The purpose is to throttle back requests when necessary to avoid overloading the hardware. TP monitors help to prevent overloading or \u0022crashing\u0022 the server with too much work."
  },
  {
     "key":502,
     "value":"transborder data",
     "description":"Data crossing a political border. This data requires special handling. Transborder risks include legality of the data, differences in legal requirements, and extra protection necessary to prevent unauthorized disclosure. Examples include data transmission between countries or between trading partners in business."
  },
  {
     "key":503,
     "value":"Transport layer",
     "description":"Layer 4 of the OSI model, responsible for the delivery of data transmissions across the network. Two common methods of data transmission are using the Transmission Control Protocol, which guarantees delivery, and using the User Datagram Protocol, which does not provide any assurance of delivery."
  },
  {
     "key":504,
     "value":"trapdoor",
     "description":"Secret point of entry into a system. Usually a hidden access technique left in the software by the developer for future use by the developer\u0027s technical support staff."
  },
  {
     "key":505,
     "value":"Trojan horse",
     "description":"Malicious software that is intentionally hidden inside of a normal program. The concept is analogous with the Trojan horse story of ancient times."
  },
  {
     "key":506,
     "value":"tuple",
     "description":"A row in a database, also known as the attribute of a particular data record."
  },
  {
     "key":507,
     "value":"two-factor authentication",
     "description":"The processes of basing a decision regarding the user\u0027s identity on two pieces of information—usually, the user password and a unique physical characteristic of the user. Two-factor authentication is also known as strong authentication."
  },
  {
     "key":508,
     "value":"unclassified information",
     "description":"Unclassified information is synonymous with public records or unprotected data. This type of design has been used for hundreds, if not thousands, of years in government, military, and commerce. Anyone may have access to the contents."
  },
  {
     "key":509,
     "value":"unicast",
     "description":"A technical method used to transmit data to a single destination on the network."
  },
  {
     "key":510,
     "value":"uninterruptible power supply (UPS)",
     "description":"An intelligent device that monitors commercial power and delivers supplemental battery power when necessary. The purpose of the UPS is to provide supplemental electricity for a brief period of time until the systems can be shut down. The UPS may have the capability to start an electric generator for extended runtimes during a power outage."
  },
  {
     "key":511,
     "value":"unit testing",
     "description":"A testing technique to verify the functionality of an individual program module."
  },
  {
     "key":512,
     "value":"Universal Description, Discovery, and Integration (UDDI) protocol",
     "description":"An online directory used in XML programming to identify available web services."
  },
  {
     "key":513,
     "value":"unqualified opinion",
     "description":"The auditor has no reservations about their findings, and there are no special restrictions on the use of the audit report. Also see qualified opinion."
  },
  {
     "key":514,
     "value":"uptime",
     "description":"Refers to the system or resource being available for the user whenever they care to use it. Uptime is reported in simple comparison to all forms of downtime. Service-level agreements need to specify how uptime is reported and the specific operating hours in which each system must be up and available for the user."
  },
  {
     "key":515,
     "value":"user acceptance testing (UAT)",
     "description":"A formal process of verifying that the system meets the user\u0027s requirements during the SDLC implementation phase."
  },
  {
     "key":516,
     "value":"User Datagram Protocol (UDP)",
     "description":"Provides for connectionless sessions with lower overhead by using Internet Protocol. UDP sessions are a best effort and will not ensure delivery to the destination."
  },
  {
     "key":517,
     "value":"variable sampling",
     "description":"Used to designate a prorated dollar amount or weight of effectiveness to an entire subject population."
  },
  {
     "key":518,
     "value":"version control",
     "description":"Tracking the details of tiny changes inside of software versions and revisions. Version control is the foundation of configuration management. Each change introduces the likelihood of unexpected consequences. Also see configuration management."
  },
  {
     "key":519,
     "value":"virtual",
     "description":"Synonym for fake or not real. May appear as simulated computer, server, or user. It could be simulation software to make another program pretend to be a server."
  },
  {
     "key":520,
     "value":"virtual local area network (VLAN)",
     "description":"An artificial grouping of systems into a common broadcast domain, also known as a subnetwork. Similar to a conference call between computers instead of people."
  },
  {
     "key":521,
     "value":"virtual machine",
     "description":"A software partition simulating private processing, memory, and computer interfaces. The design was created for service bureaus using mainframes with different users running their own programs in time-sharing mode. Each partition is protected by isolation from the other partitions to prevent any disruption. The virtual machine concept has been copied for use in small computers by VMware, Parallels, and the Java Virtual Machine (JVM)."
  },
  {
     "key":522,
     "value":"virtual memory",
     "description":"See swap space."
  },
  {
     "key":523,
     "value":"virtual private network (VPN)",
     "description":"One method of providing secure access to a network for a remote user."
  },
  {
     "key":524,
     "value":"virus",
     "description":"A malicious, self-replicating computer program that spreads itself through the system as infected computer programs are executed. Viruses can destroy data and program files."
  },
  {
     "key":525,
     "value":"volatile data",
     "description":"Information in the computer\u0027s working memory (RAM) that will be lost when power is shut off. Also see nonvolatile data."
  },
  {
     "key":526,
     "value":"vulnerability",
     "description":"The weakness or path that can be exploited by a threat to damage an asset."
  },
  {
     "key":527,
     "value":"vulnerability assessment",
     "description":"The process of reviewing risks and vulnerabilities to determine the organization\u0027s current level of exposure."
  },
  {
     "key":528,
     "value":"walk-through testing",
     "description":"Used in disaster recovery testing to simulate the basic recovery process in order to identify and fix any errors found in procedures."
  },
  {
     "key":529,
     "value":"war chalking",
     "description":"Process of physically marking insecure wireless access points that are insecure and therefore provide unauthorized access to the internet. Most war chalking has evolved into downloadable maps available on the Internet."
  },
  {
     "key":530,
     "value":"war driving",
     "description":"Process of driving through a neighborhood with technical tools to detect insecure wireless access points."
  },
  {
     "key":531,
     "value":"war walking",
     "description":"Similar to war driving but, as the name suggests, involves walking instead of driving."
  },
  {
     "key":532,
     "value":"warm site",
     "description":"A facility that has basic utility services installed and some computer equipment but lacks other computer equipment necessary for recovery from a disaster. A warm site needs to be built out before it can be used. It can be ready in days or weeks. A warm site offers a lower chance of success than a hot site."
  },
  {
     "key":533,
     "value":"waterfall model",
     "description":"An early software development model that cascades the completion of each phase into the next phase."
  },
  {
     "key":534,
     "value":"weak authentication",
     "description":"See single-factor authentication."
  },
  {
     "key":535,
     "value":"Web Services Description Language (WSDL)",
     "description":"Identifies the format used in the programming of XML objects."
  },
  {
     "key":536,
     "value":"wet pipe",
     "description":"A fire-suppression system with water stored in the pipes at all times. This type of system is susceptible to corrosion and freezing."
  },
  {
     "key":537,
     "value":"white hat",
     "description":"An honest software tester working in the security or audit department under a formal, structured test procedure to determine system vulnerabilities by using known hacker techniques. This individual never has any staff responsibilities in IT operations, to preserve the separation of duties."
  },
  {
     "key":538,
     "value":"white-box testing",
     "description":"Testing that checks the integrity of transactions while allowing the programmer to view the logical paths through the software. Also known as program code review. Internally developed software-programming scripts and pseudocode templates in human-readable form (not compiled) may be subjected to white-box tests. Conversely, compiled software is not readable and must be tested using black-box testing techniques. Also see pseudocode and black-box testing."
  },
  {
     "key":539,
     "value":"wide area network (WAN)",
     "description":"A computer network providing user access in multiple cities."
  },
  {
     "key":540,
     "value":"wiping utility (memory wiping)",
     "description":"A special utility designed to overwrite the contents of storage media and RAM memory. This prevents any recovery of data from system memory or the hard disk. Wiping utilities can sanitize a system prior to redeployment or be used by an individual to destroy evidence. Possession of wiping utilities should be a violation of the acceptable use policy (AUP) unless specifically authorized in writing as a job requirement."
  },
  {
     "key":541,
     "value":"Wired Equivalent Privacy (WEP)",
     "description":"A symmetric-key encryption (secret key) protocol originally designed to promote wireless security. The US government published a declaration in April 2005 that all WEP installations are now considered totally insecure. Security was compromised by the industry vendor\u0027s poor choice of implementation that favors Plug and Play access over security. A radio beacon advertises the entire key to any listening device. Also see symmetric-key encryption (secret key)."
  },
  {
     "key":542,
     "value":"Wireless Application Protocol (WAP)",
     "description":"Loosely based on the OSI model and designed to display data on small screens with the limited resources of handheld devices."
  },
  {
     "key":543,
     "value":"work in process (WIP)",
     "description":"Work tasks or data currently being processed at the time of disruption. Business continuity and disaster recovery plans need to identify how work in process will be recovered. The recovered work in process (RWIP) must be reprocessed in a timely manner to avoid violating a legal deadline (LD). Also see recovered work in process (RWIP) and legal deadline (LD)."
  },
  {
     "key":544,
     "value":"working papers",
     "description":"The auditor\u0027s notes, checklists, audit procedures, and results of audit testing. These documents must be kept secure via electronic file backup. The auditee is not permitted to see the working papers."
  },
  {
     "key":545,
     "value":"worm",
     "description":"A malicious computer program that can travel independently through the network and infect systems."
  },
  {
     "key":546,
     "value":"write blocker",
     "description":"A device used in forensic investigations to prevent any changes to the original data on the hard disk or media during bitstream imaging. Without a write blocker, the original media is considered tainted, tampered, or contaminated by any form of unintentional change that occurs during the investigation. Also see bitstream imaging."
  },
  {
     "key":547,
     "value":"XML",
     "description":"See Extensible Markup Language (XML)."
  },
  {
     "key":548,
     "value":"zero-day attack",
     "description":"Any attack that has not been seen before. Virus scanners, firewalls, and intrusion detection and prevention systems can\u0027t stop zero-day attacks because the hacker has discovered a new attack method. Most zero-day attacks exploit vulnerabilities in middleware or default settings."
  }
]